import React, { useRef, useState, useEffect } from "react";
//import { API } from "aws-amplify";
import { getRecibaSeriales, listRecibaUltimoNumeros } from "../graphql/queries";
import {
  createReciba as createRecibaMutation, updateReciba as updateRecibaMutation, updateRecibaSeriales,
  createRecibaUltimoNumero, updateRecibaUltimoNumero, updateLocacion, createRecibaSeriales, createUbicacion,
  updateUbicacion,
  createRecibaSerialesMP,
  updateRecibaSerialesMP,
  deleteRecibaSerialesMP,
} from "../graphql/mutations";
import Moment from "moment";
import { useReactToPrint } from "react-to-print";
import {
  GetUbicacion, GetClientes, GetReciba, GetUsuarios, GetRecibaID, GetRecibaSeriales, GetLocaciones, GetProductos,
  GetRecibaSerialesID,
  GetRecibaSerialesMP,
  GetProductosID,
} from "../components/queries/Queries";
import * as xlsx from "xlsx";
import { ObtenerSeriales, ObtenerUbicaciones } from "../components/queries/DCUbicaciones";
import { F } from "caniuse-lite/data/agents";
import { actualizarRecibas, manageResumenOperacion } from "../components/queries/Mutations";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

//Variables que almacenan los datos del cliente
const initialFormState = {
  numero: "", clienteID: "", cliente: "", fechaDeReciba: Moment(new Date()).format("YYYY-MM-DD"),
  horaDeReciba: Moment(new Date()).format("HH:mm"), cantidadRecibida: 0, po: "", status: "En reciba", quienInspecciono: "",
  comentarios: "", packings: "", lotes: "", numerosdeParte: "", seriales: "", serialesBTI: "", serialesID: [], activo: true, Reg_Ins_Usuario: "", Reg_Mod_Usuario: "",
};

const initialfFormState = { formType: "Reciba" };

export default function useReciba() {
  //Declaración de variables
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  const [reciba, setReciba] = useState([]);
  const [locaciones, setLocaciones] = useState([]);
  const [locacionesSinFiltro, setLocacionesSinFiltro] = useState([]);
  const [recibaSerialesSinFiltro, setRecibaSerialesSinFiltro] = useState([]);
  const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
  const [serialesRepetidos, setSerialesRepetidos] = useState([]);
  const [mRecibas, setMRecibas] = useState([]);
  const [mRecibasNP, setMRecibasNP] = useState([]);
  const [formState, updateFormState] = useState(initialfFormState);
  const [formData, updateFormData] = useState(initialFormState);
  const [dataEditar, setDataEditar] = useState({});
  const [isDisabled, setisDisabled] = useState(false);
  const [estadoReciba, setEstadoReciba] = useState("todos");
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("cliente");
  const [totalRecords, setTotalRecords] = useState(0);
  const [faltanDatos, setFaltanDatos] = useState(false);
  const [mEstatusUbicacion, setMEstatusUbicacion] = useState(false);
  const [mDatosInspeccion, setMDatosInspeccion] = useState(false);
  const [faltanDatosUbicacion, setFaltanDatosUbicacion] = useState(false);
  const [agregarLoteFaltante, setAgregarLoteFaltante] = useState(true);
  const { formType } = formState;
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const userName = window.$name;
  const ppreciba = window.$Reciba ? window.$Reciba : false;
  const pincoming = window.$Incoming ? window.$Incoming : false;
  const pdescargarreciba = window.$RecibaDescargar ? window.$RecibaDescargar : false;
  const pdescargarincoming = window.$IncomingDescarga ? window.$IncomingDescarga : false;
  const [aVisible, setAVisible] = useState(false);
  const [cargando, setCargando] = useState(false);
  const onDismiss = () => setAVisible(false);
  const [inputList, setInputList] = useState([]);
  //const [inputListParte, setInputListParte] = useState([{ packing: '', packingindex: 0, parteindex: 0, productoID: '', numerodeParte: '', descripcion: '', cantidadporParte: 0, materialEn: 'Contenedor' }]);
  const [inputListPacking, setInputListPacking] = useState([]);
  const [inputUbicaciones, setInputUbicaciones] = useState([
    {
      ubicacion: "Almacén",
      fechaIngreso: Moment(new Date()).format("YYYY-MM-DD"),
      horaIngreso: Moment(new Date()).format("HH:mm"),
    },
  ]);
  const [lotes, setLotes] = useState(1);
  const [partes, setPartes] = useState(1);
  const [packings, setPackings] = useState(1);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [editar, setEditar] = useState(false);
  const [iFocus, setIFocus] = useState(0);
  const [nFocus, setNFocus] = useState("numerodeParte");
  const [result, setResult] = useState("");
  const [indexImp, setIndexImp] = useState(0);
  const [indexlocacion, setIndexlocacion] = useState(0);
  const [nombreUsuario, setNombreUsuario] = useState("");
  const [registrosPorPagina, setRegistrosPorPagina] = useState(40);
  const aniosLetra = [
    { letra: "A", año: "2022" },
    { letra: "B", año: "2023" },
    { letra: "C", año: "2024" },
    { letra: "D", año: "2025" },
    { letra: "E", año: "2026" },
    { letra: "F", año: "2027" },
    { letra: "G", año: "2028" },
    { letra: "H", año: "2029" },
    { letra: "I", año: "2030" },
    { letra: "J", año: "2031" },
    { letra: "K", año: "2032" },
    { letra: "L", año: "2033" },
    { letra: "M", año: "2034" },
    { letra: "N", año: "2035" },
    { letra: "O", año: "2036" },
    { letra: "P", año: "2037" },
    { letra: "Q", año: "2038" },
    { letra: "R", año: "2039" },
    { letra: "S", año: "2040" },
    { letra: "T", año: "2041" },
    { letra: "U", año: "2042" },
    { letra: "V", año: "2043" },
    { letra: "W", año: "2044" },
    { letra: "X", año: "2045" },
    { letra: "Y", año: "2046" },
    { letra: "Z", año: "2047" },
  ];
  const mesNumero = [
    { mes: "01", numero: "1" },
    { mes: "02", numero: "2" },
    { mes: "03", numero: "3" },
    { mes: "04", numero: "4" },
    { mes: "05", numero: "5" },
    { mes: "06", numero: "6" },
    { mes: "07", numero: "7" },
    { mes: "08", numero: "8" },
    { mes: "09", numero: "9" },
    { mes: "10", numero: "10" },
    { mes: "11", numero: "11" },
    { mes: "12", numero: "12" },
  ];
  //const inputEl = useRef(null);
  const fhoy = new Date();
  var fdias = new Date();
  fdias.setDate(fdias.getDate() - 2);
  const componentRefTEV = useRef();
  const handlePrintTEV = useReactToPrint({
    content: () => componentRefTEV.current,
  });

  Moment.locale("en");
  var now = new Date();
  var now2 = new Date();
  now2.setMonth(now2.getMonth() - 1);
  const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
  const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

  async function handleScanI(data) {
    //data = data.replace('\'', '-')
    setAVisible(false);
    setCargando(true);
    if (data) {
      const serialID = data.replaceAll("'", "-");
      //Se declaran variables auxiliares.    
      var datosSerial = [];
      //Se intenta obtener el material de la reciba por ID
      if (serialID.length === 36) {
        const dReciba = await GetRecibaSerialesID(serialID);
        if (dReciba.id) {
          datosSerial.push(dReciba);
        }
      }
      if (datosSerial.length <= 0) {
        //Filtro para obtener los datos
        let filter = {
          or: [
            {
              recibaSerialID: {
                eq: serialID,
              },
            },
            {
              serialRecibaBTI: {
                eq: serialID.toUpperCase(),
              },
            },
            {
              serial: {
                eq: serialID.toUpperCase(),
              },
            },
          ],
        };
        const datosSerialMP = await GetRecibaSerialesMP(filter);

        if (datosSerialMP.length) {
          await Promise.all(
            datosSerialMP.map((serialMp) => {
              serialMp.recibaSerialMPID = serialMp.id;
              serialMp.id = serialMp.recibaSerialID;
              serialMp.updatedAt = serialMp.rsUpdatedAt;
              delete serialMp.rsUpdatedAt;
              delete serialMp.recibaSerialID;
              return serialMp;
            }));
          datosSerial = datosSerialMP;
        } else {
          //Filtro para obtener los datos
          let filter1 = {
            or: [
              {
                id: {
                  eq: serialID,
                },
              },
              {
                serialRecibaBTI: {
                  eq: serialID.toUpperCase(),
                },
              },
              {
                serial: {
                  eq: serialID.toUpperCase(),
                },
              },
            ],
          };
          datosSerial = await GetRecibaSeriales(filter1);
        }
      }

      if (datosSerial.length) {
        if (datosSerial[0].activo === true) {
          const listas = await fetchRecibaporID(datosSerial[0].recibaID);
          setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
          updateFormData({ ...listas, Reg_Mod_Usuario: userName });
          setInputList(datosSerial.map((sA) => ({
            ...sA, fechaDeUbicacion: sA.fechaDeUbicacion ? sA.fechaDeUbicacion : Moment(new Date()).format("YYYY-MM-DD"),
            horaDeUbicacion: sA.horaDeUbicacion ? sA.horaDeUbicacion : Moment(new Date()).format("HH:mm"),
            quienInspecciono: sA.quienInspecciono ? sA.quienInspecciono : nombreUsuario, nuevo: !sA.ultimaUbicacion ? true : false,
            editar: !sA.ultimaUbicacion ? true : sA.ultimaUbicacion[1] ? false : true, locacionOriginal: sA.locacion,
            ubicacionOriginal: sA.ubicacion, statusOriginal: sA.status
          })));
          setRecibaSerialesSinFiltro(datosSerial.map((fr) => ({ ...fr, modificado: false })));
          setCargando(false);
          setAVisible(false);
          toggle3();

        } else {
          //setTextBCarga("Carga");
          window.scrollTo(0, 0);
          setMensajeAlert(
            "El material no está activo"
          );
          setColor("warning");
          setCargando(false);
          setAVisible(true);

        }
      } else {

        window.scrollTo(0, 0);
        setMensajeAlert(
          "No fue posible realizar la operación: el serial proporcionado (" + serialID + ") no coincide con ningún número de serie registrado en el sistema, favor de buscar el material que corresponda y volver a intentarlo"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);

      }
    }
    return <p>{data}</p>;
  }
  function handleScan(data) {
    setResult(data);
    if (iFocus < inputList.length && iFocus >= 0) {
      if (nFocus === "cantidadRecibida") {
        var out = "";
        var filtro = "1234567890"; //Caracteres validos
        //Recorrer el texto y verificar si el caracter se encuentra en la lista de validos
        for (var i = 0; i < data.length; i++) {
          if (filtro.indexOf(data.charAt(i)) != -1) {
            //Se añaden a la salida los caracteres validos
            out += data.charAt(i);
          }
        }
        /*if (out.length>5)*/
        out = out.substr(0, 10);
        inputList[iFocus][nFocus] = out;
      } else {
        inputList[iFocus][nFocus] = data;
      }
      if (nFocus === "numerodeParte") {
        //Busca el siguiente elemento para mandar el foco
        const productosFromAPI = productos.filter(
          (producto) =>
            producto.numerodeParte.toLowerCase().trim() ===
            data.toLowerCase().trim()
        );

        if (productosFromAPI.length > 0) {
          Promise.all(
            productosFromAPI.map((producto) => {
              inputList[iFocus].productoID = producto.id;
              inputList[iFocus].numerodeParte = producto.numerodeParte.trim();
              inputList[iFocus].descripcion = producto.descripcion;
              inputList[iFocus].precioUnitario = producto.precioUnitario;
              inputList[iFocus].divisa = producto.divisa;
              inputList[iFocus].piezasXRack = producto.piezasXRack;
              inputList[iFocus].rackTipo = producto.rackTipo;
              return inputList;
            })
          );
          inputList[iFocus].parteValido = true;
        }
        setNFocus("serial");
      }
      //Revisa si es la última fila, si es así, agrega una fila nueva en blanco
      if (inputList[iFocus].ultimoxpacking === true) {
        inputList[iFocus].ultimoxpacking = false;
        const list = [
          ...inputList,
          {
            materialEn: "Contenedor",
            materialEnCantidad: 1,
            packing: inputList[iFocus].packing,
            packingindex: inputList[iFocus].packingindex,
            productoID: "",
            numerodeParte: "",
            po: inputList[iFocus].po,
            descripcion: "",
            cantidadporParte: 0,
            recibaID: "",
            lote: agregarLoteFaltante ? "ND" : "",
            sombreado: false,
            primeroxpacking: false,
            ultimoxpacking: true,
            serial: "",
            cantidadRecibida: "",
            ubicacion: "Reciba",
            locacion: "",
            fechaDeUbicacion: "",
            horaDeUbicacion: "",
            orden: inputList[iFocus].orden + 1,
            status: "En reciba",
            quienInspecciono: "",
            comentariosdeinspeccion: "",
            activo: true,
            Reg_Ins_Usuario: userName,
            manual: true,
            parteValido: false,
            fid: "i" + inputList.length,
            espacioOcupado: 0,
          },
        ];

        setInputList(list);
      } else {
        const list = [...inputList];
        setInputList(list);
      }
      if (nFocus === "serial") {
        //Busca el siguiente elemento para mandar el foco
        setNFocus("cantidadRecibida");
      }
      if (nFocus === "cantidadRecibida") {
        //Busca el siguiente elemento para mandar el foco
        setIFocus(iFocus + 1);
        setNFocus("numerodeParte");
        //setNFocus("lote");
      }
      /*if (nFocus==="lote"){
                //Busca el siguiente elemento para mandar el foco  
                
                setIFocus(iFocus+1);
                setNFocus("numerodeParte"); 
            } */
    }
  }
  function handleError(err) {
    console.error(err);
  }

  // current page
  const [currentPage, setCurrentPage] = useState(1);

  // total records per page to display
  const recordPerPage = 20;

  // range of pages in paginator
  const pageRange = 5;

  //renglones por página a imprimir en Incoming


  function toggle() {
    setModal(!modal);
  }
  function toggle1() {
    setModal1(!modal1);
  }
  function toggle2() {
    setModal2(!modal2);
  }
  function toggle3() {
    setModal3(!modal3);
  }
  function clicEliminar(reciba) {
    setModal(!modal);
    setFaltanDatos(false);
    updateFormData({ ...reciba, Reg_Mod_Usuario: userName });
    setMRecibas(reciba);
  }
  async function clicDescargarDatos(operacion) {
    setCargando(true);
    setAVisible(false);
    //Declaración de variables
    var recibaPF = [];
    var recibaDD = [];
    var recibaDDI = [];
    var recibaPD = recibaSinFiltro;
    var recibaDetalle = await fetchRecibaSerialporFechas(rfechaini, rfechafin);
    //Se ordenan los datos de la reciba por fecha de reciba
    recibaPD = recibaPD.sort((a, b) =>
      a.fechaDeReciba > b.fechaDeReciba
        ? 1
        : a.fechaDeReciba < b.fechaDeReciba
          ? -1
          : 0
    );
    var fecha = "";
    //Se obtienen los datos en el orden requerido
    await Promise.all(
      recibaPD.map((reciba) => {
        //Si la fecha de reciba es diferente a la última fecha revisada.
        if (reciba.fechaDeReciba !== fecha) {
          //La fecha se actualiza a la que se está leyendo
          fecha = reciba.fechaDeReciba;
          //Se declara una constante en la que se asignan los datos de las recibas de la fecha que se está trabajando
          // y se ordena por fecha de creación
          const recibaFecha = recibaPD
            .filter((rfecha) => rfecha.fechaDeReciba === fecha)
            .sort((a, b) =>
              a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0
            );
          //Se recorre el array de las recibas de la fecha que se está trabajando para obtener los datos de la reciba
          //en el formato requerido.
          recibaFecha.map((recibaf, i) => {
            var nowrf = new Date(fecha);
            nowrf.setDate(nowrf.getDate() + 3);
            //Se obtienen los datos del detalle de la reciba en cuestión
            const recibaDDFecha = recibaDetalle
              .filter((rdfecha) => rdfecha.numero === recibaf.numero)
              .sort((a, b) =>
                a.createdAt > b.createdAt
                  ? 1
                  : a.createdAt < b.createdAt
                    ? -1
                    : 0
              );
            recibaDDFecha.map((recibadf, i) => {
              //Datos de detalle.
              recibaDD.push({
                RECIBA: recibadf.numero,
                CLIENTE: recibadf.cliente,
                FECHA: Moment(recibaf.fechaDeReciba).format("DD-MM-YYYY"),
                "DUE DATE": Moment(nowrf).format("DD-MM-YYYY"),
                HORA: recibaf.horaDeReciba,
                "NÚMERO DE PARTE": recibadf.numerodeParte,
                LOTE: recibadf.lote,
                SERIAL: recibadf.serial,
                "SERIAL BTI": recibadf.serialRecibaBTI,
                DESCRIPCIÓN: recibadf.descripcion,
                PACKING: recibadf.packing,
                PO: recibadf.po,
                CONTENEDOR:
                  recibadf.materialEn === "Contenedor" ? recibadf.materialEnCantidad > 1 ?
                    recibadf.materialEnCantidad + "Contenedores" : recibadf.materialEnCantidad + "Contenedor" :
                    recibadf.materialEnCantidad > 1 ?
                      recibadf.materialEnCantidad + "Cajas" : recibadf.materialEnCantidad + "Caja",
                PESO: recibadf.peso ? recibadf.peso + " KG" : "",
                "CANTIDAD RECIBIDA": recibadf.cantidadRecibida,
                "PIEZAS EN ALMACÉN": recibadf.piezasenAlmacen,
                "PIEZAS EN CUARENTENA": recibadf.piezasenCuarentena,
                "CANTIDAD PLANEADA": recibadf.cantidadPlaneada,
                "PIEZAS PINTADAS": recibadf.piezasPintadas,
                "PIEZAS EMBARCADAS": recibadf.piezasEmbarcadas,
                "PIEZAS EN RECUPERACIÓN": recibadf.piezasTRecuperacion,
                "ÚLTIMA UBICACIÓN": recibadf.ultimaUbicacion
                  ? JSON.stringify(recibadf.ultimaUbicacion)
                    .replace('["{', "{")
                    .replace('}"]', "}")
                    .replace('}"', "}")
                    .replace('"{', "{")
                  : "",
                ESTATUS: recibadf.status,
                RECIBIÓ: recibaf.quienInspecciono,
                COMENTARIOS: recibadf.comentariosdeinspeccion,
              });
              //Se agregan los datos de la reciba
              recibaPF.push({
                CLIENTE: recibaf.cliente,
                FECHA: Moment(recibaf.fechaDeReciba).format("DD-MM-YYYY"),
                "DUE DATE": recibaf.dueDate ? recibaf.dueDate : Moment(nowrf).format("DD-MM-YYYY"),
                HORA: recibaf.horaDeReciba,
                "NÚMERO DE PARTE": recibadf.numerodeParte,
                LOTE: recibadf.lote,
                SERIAL: recibadf.serial,
                DESCRIPCIÓN: recibadf.descripcion,
                PACKING: recibadf.packing,
                CANTIDAD: recibadf.cantidadRecibida,
                CONTENEDOR: recibadf.materialEn === "Contenedor" ? recibadf.materialEnCantidad > 1 ?
                  recibadf.materialEnCantidad + "Contenedores" : recibadf.materialEnCantidad + "Contenedor" :
                  recibadf.materialEnCantidad > 1 ?
                    recibadf.materialEnCantidad + "Cajas" : recibadf.materialEnCantidad + "Caja",
                PROCESO: "P/PINTURA",
                RECIBIÓ: recibadf.quienInspecciono,
                ESTATUS: recibadf.status,
                COMENTARIOS: recibadf.comentariosdeinspeccion +
                  (recibadf.comentariosdecuarentena ? " ," + recibadf.comentariosdecuarentena : "")
                  + (recibaf.comentarios ? " ," + recibaf.comentarios : "")
                  + (recibadf.defectoCuarentena ? " ," + recibadf.defectoCuarentena : ""),
                RECIBA: recibaf.numero,
              });
              //Datos de reciba para Incoming
              recibaDDI.push({
                "#": i + 1,
                Reciba: recibadf.numero,
                "Packing o Line": recibadf.packing,
                "Número de parte": recibadf.numerodeParte,
                "Desripción": recibadf.descripcion,
                Lote: recibadf.lote,
                Serial: recibadf.serial,
                "Serial BTI": recibadf.serialRecibaBTI,
                "Cantidad": recibadf.cantidadRecibida,
                Estatus: recibadf.status,
                "Fecha de ubicación": Moment(recibadf.fechaDeUbicacion).format("DD-MM-YYYY"),
                "Hora de ubicación": recibadf.horaDeUbicacion,
                "Quién inspeccionó": recibadf.quienInspecciono,
                "Defecto": recibadf.defectoCuarentena,
                Comentarios: recibadf.comentariosdeinspeccion,
                "Empaque libre de daños": recibadf.empaqueSinDanos,
                "Material correcto/no mezclado": recibadf.materialCorrecto,
                "Material no contaminado con oxido, grasas, material extraño": recibadf.materialNContaminado,
                "Material sin defectos obvios (piezas dobladas o golpeadas)": recibadf.materialSinDefectosOvios,
                "Prueba de solubilidad": recibadf.pruebaSolubilidad,
                "Espesor": recibadf.espesor,
              });
            });
          });
          //
        }

        //return reciba
      })
    );

    if (operacion === "copiageneral") {
      var worksheet = xlsx.utils.json_to_sheet(recibaPF, { skipHeader: true });
      navigator.clipboard.writeText(xlsx.utils.sheet_to_csv(worksheet));
      setMensajeAlert("Datos copiados al Portapepeles");
    }
    if (operacion === "copiadetalle") {
      var worksheet1 = xlsx.utils.json_to_sheet(recibaDD, { skipHeader: true });
      navigator.clipboard.writeText(xlsx.utils.sheet_to_csv(worksheet1));
      setMensajeAlert("Datos copiados al Portapepeles");
    }
    if (operacion === "descarga") {
      var worksheet = xlsx.utils.json_to_sheet(recibaPF);
      var worksheet1 = xlsx.utils.json_to_sheet(recibaDD);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Reciba");
      xlsx.utils.book_append_sheet(workbook, worksheet1, "Detalle");
      xlsx.writeFile(
        workbook,
        "Reciba del " + rfechaini + " al " + rfechafin + ".xlsx"
      );
      setMensajeAlert("Datos descargados");
    }
    if (operacion === "descargaIncoming") {
      var worksheet = xlsx.utils.json_to_sheet(recibaDDI);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Reciba");
      xlsx.writeFile(
        workbook,
        "Registro de Incoming " + rfechaini + " al " + rfechafin + ".xlsx"
      );
      setMensajeAlert("Datos descargados");
    }

    setColor("info");
    setAVisible(true);
    setCargando(false);
  }
  async function clicDescargarDatosReciba(reciba) {
    setCargando(true);
    setAVisible(false);
    //Declaración de variables
    var recibaPF = [];
    var recibaDetalle = await ObtenerSeriales(reciba.serialesID);//GetRecibaSeriales({ recibaID: { eq: reciba.id } });
    recibaDetalle = recibaDetalle.sort((a, b) =>
      a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0);
    //Se obtienen los datos en el orden requerido
    await Promise.all(
      recibaDetalle.map((recibaf) => {
        //Se agregan los datos de la reciba
        recibaPF.push({
          CLIENTE: reciba.cliente,
          FECHA: Moment(reciba.fechaDeReciba).format("DD-MM-YYYY"),
          "DUE DATE": reciba.dueDate,
          HORA: reciba.horaDeReciba,
          "NÚMERO DE PARTE": recibaf.numerodeParte,
          LOTE: recibaf.lote,
          SERIAL: recibaf.serial,
          DESCRIPCIÓN: recibaf.descripcion,
          PACKING: recibaf.packing,
          CANTIDAD: recibaf.cantidadRecibida,
          CONTENEDOR: recibaf.materialEn === "Contenedor" ? recibaf.materialEnCantidad > 1 ?
            recibaf.materialEnCantidad + "Contenedores" : recibaf.materialEnCantidad + "Contenedor" :
            recibaf.materialEnCantidad > 1 ?
              recibaf.materialEnCantidad + "Cajas" : recibaf.materialEnCantidad + "Caja",
          PROCESO: "P/PINTURA",
          RECIBIÓ: reciba.quienInspecciono,
          ESTATUS: recibaf.status,
          COMENTARIOS: recibaf.comentariosdeinspeccion +
            (recibaf.comentariosdecuarentena ? " ," + recibaf.comentariosdecuarentena : "")
            + (reciba.comentarios ? " ," + reciba.comentarios : "")
            + (recibaf.defectoCuarentena ? " ," + recibaf.defectoCuarentena : ""),
          RECIBA: reciba.numero,
        });

        //sreturn recibaf;
      })
    );
    var worksheet = xlsx.utils.json_to_sheet(recibaPF, { skipHeader: true });
    navigator.clipboard.writeText(xlsx.utils.sheet_to_csv(worksheet));
    setMensajeAlert("Datos copiados al Portapepeles");
    setColor("info");
    setAVisible(true);
    setCargando(false);
  }

  async function clicEditar(reciba, clienteID, recibaNumero, cliente) {
    setAVisible(false);
    setCargando(true);
    setEditar(true);
    const listas = await fetchRecibaporID(reciba.id);
    const seriales = await fetchRecibaSerialporID(reciba, "Editar");
    setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
    updateFormData({ ...listas, Reg_Mod_Usuario: userName });
    setDataEditar({ ...listas, Reg_Mod_Usuario: userName })
    fetchProductos(clienteID);
    const agregarLoteF = cliente === "Olson Internacional" ? false : true;

    setAgregarLoteFaltante(agregarLoteF);

    const packings = obtenerPacking(
      seriales.sort((a, b) =>
        a.packingindex > b.packingindex
          ? 1
          : a.packingindex < b.packingindex
            ? -1
            : 0
      )
    );
    setInputListPacking(packings);
    setInputList(
      obtenerSeriales(
        seriales.sort((a, b) =>
          a.numerodeParte > b.numerodeParte
            ? 1
            : a.numerodeParte < b.numerodeParte
              ? -1
              : 0
        ),
        packings,
        agregarLoteF
      )
    );
    setCargando(false);
    updateFormState(() => ({
      ...formState,
      formType: "Editar Reciba " + recibaNumero,
    }));
    setIFocus(-1);
    setNFocus("numerodeParte");
  }
  async function cliclMostrar(reciba) {
    window.scrollTo(0, 0);
    setCargando(true);
    setFaltanDatos(false);
    setAVisible(false);
    const listas = await fetchRecibaporID(reciba.id);
    setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
    const seriales = await fetchRecibaSerialporID(reciba, "Mostrar");
    const packings = obtenerPacking(seriales.sort((a, b) => a.packingindex > b.packingindex ? 1
      : a.packingindex < b.packingindex ? -1 : 0));
    setInputList(obtenerSerialesMostrar(seriales.sort((a, b) => a.numerodeParte > b.numerodeParte ? 1 :
      a.numerodeParte < b.numerodeParte ? -1 : 0), packings, false));
    const serialesNP = seriales.filter(serial => (serial.sporNP ? serial.sporNP : false) === true);
    if (serialesNP.length > 0) { setMRecibasNP(obtenerSerialesMostrarNP(serialesNP)); } else { setMRecibasNP([]) }
    /*const seriales = await ObtenerSeriales(reciba.serialesID);
    setInputList(seriales);*/
    updateFormState(() => ({
      ...formState,
      formType: "Detalle Reciba " + reciba.numero,
    }));
    setCargando(false);
  }

  async function cliclIncoming(reciba) {
    setMEstatusUbicacion(false);
    setMDatosInspeccion(false);
    fetchLocacionDisponible();
    setCargando(true);
    setAVisible(false);
    const listas = await fetchRecibaporID(reciba.id);
    setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
    updateFormData({ ...listas, Reg_Mod_Usuario: userName });
    const seriales = await fetchRecibaSerialporID(reciba, "Incoming");
    const packings = obtenerPacking(
      seriales.sort((a, b) =>
        a.packingindex > b.packingindex
          ? 1
          : a.packingindex < b.packingindex
            ? -1
            : 0
      )
    );
    seriales.map((serial) => {
      if (serial.fechaDeUbicacion === "")
        serial.fechaDeUbicacion = Moment(new Date()).format("YYYY-MM-DD");
      if (serial.horaDeUbicacion === "")
        serial.horaDeUbicacion = Moment(new Date()).format("HH:mm");
      return serial;
    });
    const Datoslist = obtenerSerialesMostrar(seriales.sort((a, b) => a.numerodeParte > b.numerodeParte ? 1
      : a.numerodeParte < b.numerodeParte ? -1 : 0), packings, true);
    setCargando(false);
    setRecibaSerialesSinFiltro(Datoslist.map((fr) => ({ ...fr, modificado: false })));
    setInputList(Datoslist);
    updateFormState(() => ({
      ...formState,
      formType: "Incoming Reciba " + reciba.numero,
    }));
  }

  function aceptarEliminar() {
    setModal(!modal);
    //updateFormData({ ...formData, Reg_Mod_Usuario: userName , activo:true});
    eliminarReciba();
  }
  // handle change event
  function handlePageChange(pageNumber) {
    setAVisible(false);
    setCargando(false);
    setCurrentPage(pageNumber);
    busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber);
  }

  function onestadoReciba(e) {
    setAVisible(false);
    setCargando(false);
    setEstadoReciba(e.target.value);
    busqueda(recibaSinFiltro, e.target.value, searchBy, search, currentPage);
  }

  async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage) {
    /* setMensajeAlert(search);
         setColor("warning");
         setAVisible(true);*/
    var pag = 1;
    var bandera = 1;
    //Filtrado de datos por la búsqueda y el estado de reciba
    const recibaFromAPI = recibasinf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((reciba) =>
        estadoReciba === "todos"
          ? reciba.status === reciba.status
          : reciba.status === estadoReciba
      )
      .filter((reciba) =>
        searchb === "numero de parte"
          ? reciba.numerosdeParte.toLowerCase().includes(search.toLowerCase())
          : searchb === "cliente"
            ? reciba.cliente.toLowerCase().includes(search.toLowerCase())
            : searchb === "id de reciba"
              ? reciba.numero.toLowerCase().includes(search.toLowerCase())
              : searchb === "serial"
                ? reciba.seriales.toLowerCase().includes(search.toLowerCase())
                : searchb === "serialBTI"
                  ? reciba.serialesBTI.toLowerCase().includes(search.toLowerCase())
                  : searchb === "paking"
                    ? reciba.packings.toLowerCase().includes(search.toLowerCase())
                    : searchb === "lote"
                      ? reciba.lotes.toLowerCase().includes(search.toLowerCase())
                      : reciba.fechaDeReciba == search
      );

    //Implementa la paginación.
    //Se indica qué página le corresponde a cada registro.
    await Promise.all(
      recibaFromAPI.map(async (reciba) => {
        //producto.indexnum=bandera;
        reciba.indexpag = pag;
        bandera++;
        if (bandera > recordPerPage) {
          bandera = 1;
          pag++;
        }

        return reciba;
      })
    );

    //Se obtiene el tamaño del Array que contiene los datos filtrados de la reciba.
    const lengthreciba = recibaFromAPI.length;
    //Sí no hay datos después del filtrado en el Array, se establece la página actual a 1
    if (lengthreciba <= 0) setCurrentPage(1);

    //A la variable reciba se le asignan los datos ya filtrados y con paginación.
    setReciba(
      recibaFromAPI
        .filter((reciba) => reciba.indexpag === currentPage)
        .sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
        )
    );

    //Se asigna el total de los registros filtrados a la variable totalRecords
    setTotalRecords(lengthreciba);

    //Se revisa si el usuario está en una página mayor a la 1 y los datos resultantes del filtro son mayor a 0,
    //si es así, se determina en qué página se debe posicionar al usuario después de aplicar el filtro.
    if (currentPage > 1 && lengthreciba > 0) {
      const prepaginas = parseInt(lengthreciba / recordPerPage);
      const paginas =
        prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;

      if (currentPage > paginas) {
        setCurrentPage(paginas);
        const recibaFromAPIp = recibaFromAPI
          .sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
          .filter((reciba) => reciba.indexpag === paginas);
        setReciba(
          recibaFromAPIp.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
        );
      }
    }
    setCargando(false);
  }
  //Método useEffect
  useEffect(() => {
    //fetchReciba();
    fetchClientes();
    fetchLocacion();
    fetchUsuario();
  }, []);

  //Obtiene el nombre de usuario del usuario logueado
  async function fetchUsuario() {
    //Filtro por planeación activa
    let filter = {
      usuario: {
        eq: userName,
      },
    };
    const apiData = await GetUsuarios(filter);
    const dataFromAPI = apiData.sort((a, b) =>
      a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
    );
    if (dataFromAPI[0]) setNombreUsuario(dataFromAPI[0].nombreCompleto);
  }

  //Obtiene los datos guardados de los clientes
  async function fetchClientes() {
    //Filtro por cliente activo
    let filter = {
      activo: {
        eq: true,
      },
    };

    //const apiData = await API.graphql({ query: listClientes, variables: { filter: filter, limit: 100000000 } });
    const apiData = await GetClientes(filter);
    setClientes(apiData);
    fetchReciba();
  }

  //Obtiene los datos guardados de los productos
  async function fetchProductos(claveCliente) {
    //Filtro por cliente
    let filter = {
      clienteID: {
        eq: claveCliente,
      },
      activo: {
        eq: true,
      },
    };
    //Se obtienen los datos de los productos, por clientes
    const apiData = await GetProductos(filter);
    setProductos(apiData);
  }

  //Obtiene los datos guardados de Reciba
  async function fetchReciba(fechainicial, fechafinal) {
    //const AlertVisible=aVisible;
    //setAVisible(false);
    setCargando(true);
    var pag = 1;
    var bandera = 1;

    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDeReciba: {
            ge: !fechainicial ? rfechaini : fechainicial,
          },
        },
        {
          fechaDeReciba: {
            le: !fechafinal ? rfechafin : fechafinal,
          },
        },
      ],
    };

    //Obtiene los datos de las recibas
    const apiData = await GetReciba(filter);
    const recibaFromAPI = apiData.sort((a, b) =>
      a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
    );

    await Promise.all(
      recibaFromAPI.map(async (reciba) => {
        reciba.indexpag = pag;
        bandera++;
        if (bandera > recordPerPage) {
          bandera = 1;
          pag++;
        }
        return reciba;
      })
    );
    /*fetchRecibaSerialporFechas(
      !fechainicial ? rfechaini : fechainicial,
      !fechafinal ? rfechafin : fechafinal
    );*/
    setRecibaSinFiltro(recibaFromAPI);

    busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage);
    //setAVisible(AlertVisible);
  }

  //Obtiene los datos guardados de Reciba
  async function fetchRecibaporID(recibaID) {
    const recibaFromAPI = await GetRecibaID(recibaID);
    return recibaFromAPI;
  }

  //Obtiene los datos guardados de Reciba
  async function fetchRecibaSerialporID(reciba, Operacion) {
    /*let filter = {
      recibaID: {
        eq: reciba.id,
      },
      activo: {
        eq: true,
      },
    };
    const dataSeriales = await  GetRecibaSeriales(filter);*/
    //Obteniendo los datos de los seriales/contenedores
    var serialesID = [];
    if (reciba.serialesID.length > 0) {
      serialesID = reciba.serialesID;
    } else {
      const result = await actualizarRecibas(reciba, userName);
      if (result.completo === true) {
        serialesID = result.registros.serialesID;
      }
    }
    const dataSeriales = await ObtenerSeriales(serialesID);
    const recibaSerialesFromAPI = dataSeriales.sort((a, b) =>
      a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0
    );
    if (Operacion === "Incoming") {
      await Promise.all(
        recibaSerialesFromAPI.map(async (recibaSeriales) => {
          //const rSUbicacion = recibaUFromAPI.filter(rubicacion => rubicacion.RecibaSerialesID === recibaSeriales.id);          
          if (recibaSeriales.ultimaUbicacion) {
            if (recibaSeriales.ultimaUbicacion[1]) {
              recibaSeriales.editar = false;
              recibaSeriales.nuevo = false;
            } else {
              recibaSeriales.editar = true;
              recibaSeriales.nuevo = false;
            }
          } else {
            recibaSeriales.nuevo = true;
            recibaSeriales.editar = true;
          }

          return recibaSeriales;
        })
      );
    }

    //setRecibaSerialesSinFiltro(recibaSerialesFromAPI);
    setRecibaSerialesSinFiltro(recibaSerialesFromAPI.map((fr) => ({ ...fr, modificado: false })));
    return recibaSerialesFromAPI;
  }
  //Obtiene los datos guardados de Reciba
  async function fetchRecibaSerialporFechas(fechainicial, fechafinal) {
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDeReciba: {
            ge: fechainicial,
          },
        },
        {
          fechaDeReciba: {
            le: fechafinal,
          },
        },
      ],
    };
    //Obteniendo los datos de los seriales/contenedores
    const dataSeriales = await GetRecibaSeriales(filter);
    const recibaSerialesFromAPI = dataSeriales.sort((a, b) =>
      a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0
    );
    setRecibaSerialesSinFiltro(recibaSerialesFromAPI);
    return recibaSerialesFromAPI;
  }
  //Obtiene los datos guardados de Locación
  async function fetchLocacion() {
    let filter = {
      activo: {
        eq: true,
      },
    };

    const locacionesFromAPI = await GetLocaciones(filter);
    //Asigna las locaciones  a la variable locacionesSinFiltro
    setLocacionesSinFiltro(locacionesFromAPI);
  }
  //Obtiene los datos guardados de Locación
  async function fetchLocacionDisponible() {
    let filter = {
      activo: {
        eq: true,
      },
      ocupado: {
        eq: false,
      },
    };

    //Se obtienen las locaciones
    const apiData = await GetLocaciones(filter);
    const locacionesFromAPI = await apiData.sort((a, b) =>
      a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
    );

    setLocaciones(locacionesFromAPI);
  }

  function FaltanDatosUbicación(list) {
    var fdatos = false;
    list.map((ubicacion) => {
      if (
        !ubicacion.ubicacion ||
        !ubicacion.fechaDeUbicacion ||
        !ubicacion.horaDeUbicacion ||
        Moment(new Date()).format("YYYY-MM-DD") <
        Moment(ubicacion.fechaDeUbicacion).format("YYYY-MM-DD")
      )
        fdatos = true;
    });
    //setFaltanDatosUbicacion(fdatos);
    return fdatos;
  }

  function obtenerSeriales(list, packings, agregarLoteF) {
    var seriallist = list;
    var packingnombre = "";
    packings.map((packing, i) => {
      var norden = 1;
      seriallist.map((serial, is) => {
        serial.sombreado = false;
        serial.manual = true;
        serial.parteValido = true;
        serial.fid = "i" + is;
        if (!serial.ultimoxpacking) serial.ultimoxpacking = false;
        if (serial.packing + serial.po === packing.packing + packing.po) {
          serial.packingindex = packing.packingindex;
          serial.orden = norden;
          if (packingnombre !== packing.packing) {
            serial.primeroxpacking = true;
            packingnombre = packing.packing;
          } else {
            if (!serial.primeroxpacking) serial.primeroxpacking = false;
          }
          norden++;
        }
      });
      seriallist.push({
        materialEn: "Contenedor",
        materialEnCantidad: 1,
        packing: packing.packing,
        packingindex: packing.packingindex,
        productoID: "",
        numerodeParte: "",
        descripcion: "",
        cantidadporParte: 0,
        po: packing.po,
        recibaID: "",
        lote: agregarLoteF ? "ND" : "",
        sombreado: false,
        primeroxpacking: false,
        ultimoxpacking: true,
        serial: "",
        cantidadRecibida: "",
        ubicacion: "Reciba",
        locacion: "",
        fechaDeUbicacion: "",
        horaDeUbicacion: "",
        orden: norden,
        status: "En reciba",
        quienInspecciono: "",
        comentariosdeinspeccion: "",
        activo: true,
        Reg_Ins_Usuario: userName,
        manual: true,
        parteValido: false,
      });
    });
    return seriallist;
  }

  function obtenerSerialesMostrar(list, packings, incoming) {
    var seriallist = [];
    var sombra = true;
    packings.map((packing, i) => {
      sombra = !sombra;
      list.map((serial) => {
        serial.scolor = "";
        if (serial.packing === packing.packing) {
          serial.sombreado = sombra;
          seriallist.push(serial);
          serial.locacionOriginal = serial.locacion;
          serial.ubicacionOriginal = serial.ubicacion;
          serial.statusOriginal = serial.status;
        }
        if (
          nombreUsuario &&
          !serial.quienInspecciono &&
          serial.status === "En reciba" &&
          incoming
        )
          serial.quienInspecciono = nombreUsuario;
        if (searchBy === "serial") {
          if (serial.serial.toLowerCase().includes(search.toLowerCase())) {
            serial.scolor = "table-primary";
          }
        }
      });
    });
    return seriallist;
  }
  function obtenerSerialesMostrarNP(list) {
    var seriallist = [];
    var npSiguiente = "";
    //Se ordenan los datos por numero de parte
    const serialOrdenadoNP = list.sort((a, b) =>
      a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0);
    //Se comienza el proceso de obtención de datos
    var npActual = serialOrdenadoNP[0].numerodeParte;
    var sumaNP = { cantidadRecibidaNP: 0, materialEnCantidadNP: 0 };
    var serialAnterior = { ...serialOrdenadoNP[0] };
    serialOrdenadoNP.map((serialnp, i) => {
      //se revisa si los números de parte son los mismos     
      npSiguiente = serialnp.numerodeParte;
      setMensajeAlert("Datos obtenidos 3");
      if (npActual != npSiguiente || i === serialOrdenadoNP.length - 1) {
        //sumaNP=sumaNP+serialnp.cantidadRecibida; 
        if (i === (serialOrdenadoNP.length - 1)) {
          sumaNP.cantidadRecibidaNP = sumaNP.cantidadRecibidaNP + serialnp.cantidadRecibida;
          sumaNP.materialEnCantidadNP = sumaNP.materialEnCantidadNP + parseInt(serialnp.materialEnCantidad);
        }
        seriallist.push({ ...serialAnterior, ...sumaNP });
        //Se reinician las variables auxiliares.
        sumaNP.cantidadRecibidaNP = serialnp.cantidadRecibida;
        sumaNP.materialEnCantidadNP = parseInt(serialnp.materialEnCantidad);
        npActual = npSiguiente;
        serialAnterior = { ...serialnp }
      } else {
        sumaNP.cantidadRecibidaNP = sumaNP.cantidadRecibidaNP + serialnp.cantidadRecibida;
        sumaNP.materialEnCantidadNP = sumaNP.materialEnCantidadNP + parseInt(serialnp.materialEnCantidad);
      }
      return serialnp;
    });
    return seriallist;
  }

  function obtenerPacking(list) {
    var listPacking = [];
    var packings = "";
    var packingsn = 1;
    var listPackings = list.sort((a, b) =>
      a.packing + a.po > b.packing + b.po ? 1 : a.packing + a.po < b.packing + b.po ? -1 : 0
    );
    listPackings.map((packing, i) => {
      if (packings !== packing.packing + packing.po) {
        listPacking.push({
          packing: packing.packing,
          packingindex: packingsn,
          po: packing.po,
        });
        packingsn = packingsn + 1;
        packings = packing.packing + packing.po;
      }
      return packing;
    });
    setPackings(packingsn);
    return listPacking;
  }
  // handle click event of the Remove button
  function liberarLocaciones() {
    inputList.map((series, i) => {
      if (
        series.locacion !== "" &&
        series.locacion !== series.locacionOriginal
      ) {
        const locacionae = locacionesSinFiltro.filter(
          (locacion) => locacion.locacion === series.locacion
        );
        if (locacionae[0]) {
          liberarlocacion(locacionae[0]);
        }
      }
    });
  }

  // handle click event of the Remove button
  function liberarLocacionesLote(lote) {
    if (lote === 0) {
      inputList.map((series) => {
        if (series.locacion !== "") {
          const locacionae = locacionesSinFiltro.filter(
            (locacion) => locacion.locacion === series.locacion
          );
          series.locacion = "";
          if (locacionae[0]) {
            liberarlocacion(locacionae[0]);
          }
        }
      });
    }
  }
  //Revisa si hay cambios en los datos
  function cambioSerial(list) {
    const list1 = list.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0);
    const list2 = recibaSerialesSinFiltro.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0);
    if (editar === true) {
      list1.map((seriales, index) => {
        if (seriales.ultimoxpacking === false) {
          seriales.modificado = false;
          if (!seriales.id) {
            seriales.modificado = true;
          } else if (((seriales.packing ? list[index].packing : "") != (list2[index].packing ? list2[index].packing : "")) ||
            (seriales.po != list2[index].po) ||
            (seriales.numerodeParte != list2[index].numerodeParte) ||
            (seriales.serial != list2[index].serial) ||
            (seriales.cantidadRecibida != list2[index].cantidadRecibida) ||
            (seriales.lote != list2[index].lote) ||
            (seriales.materialEn != list2[index].materialEn) ||
            (seriales.materialEnCantidad != list2[index].materialEnCantidad) ||
            (seriales.peso != list2[index].peso) ||
            (seriales.activo != list2[index].activo) ||
            (seriales.Ecoat != list2[index].Ecoat) ||
            (seriales.Pcoat != list2[index].Pcoat) ||
            (seriales.Platinado != list2[index].Platinado) ||
            formData.clienteID != dataEditar.clienteID ||
            formData.cliente != dataEditar.cliente ||
            formData.fechaDeReciba != dataEditar.fechaDeReciba ||
            formData.horaDeReciba != dataEditar.horaDeReciba ||
            formData.quienInspecciono != dataEditar.quienInspecciono ||
            formData.comentarios != dataEditar.comentarios) {
            seriales.modificado = true;
          }
        }
      });
    }
    //list[index].modificado = true;
    return list1;
  }
  //Revisa si hay cambios en los datos
  function cambioIncoming(list) {
    const list1 = list.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0);
    const list2 = recibaSerialesSinFiltro.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0);
    list1.map((seriales, index) => {
      seriales.modificado = false;
      if ((seriales.status != list2[index].status) ||
        (seriales.ubicacion != list2[index].ubicacion) ||
        (seriales.locacion != list2[index].locacion) ||
        (seriales.fechaDeUbicacion != list2[index].fechaDeUbicacion) ||
        (seriales.horaDeUbicacion != list2[index].horaDeUbicacion) ||
        (seriales.quienInspecciono != list2[index].quienInspecciono) ||
        (seriales.defectoCuarentena != list2[index].defectoCuarentena) ||
        (seriales.comentariosdeinspeccion != list2[index].comentariosdeinspeccion) ||
        (seriales.empaqueSinDanos != list2[index].empaqueSinDanos) ||
        (seriales.materialCorrecto != list2[index].materialCorrecto) ||
        (seriales.materialNContaminado != list2[index].materialNContaminado) ||
        (seriales.materialSinDefectosOvios != list2[index].materialSinDefectosOvios) ||
        (seriales.pruebaSolubilidad != list2[index].pruebaSolubilidad) ||
        (seriales.espesor != list2[index].espesor)) {
        seriales.modificado = true;
      }
    });
    //list[index].modificado = true;
    return list1;
  }

  //Revisa cambios en los inputs
  function onChanges(e) {
    e.persist();
    updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));
  }
  //Revisa cambios en la fecha de búsqueda
  function onChangesRFecha(e) {
    e.persist();
    var fechaini = rfechaini;
    var fechafin = rfechafin;
    if (e.target.name === "rfechaini") {
      fechaini = e.target.value;
    } else {
      fechafin = e.target.value;
    }
    setRfechafin(fechafin);
    setRfechaini(fechaini);
    fetchReciba(fechaini, fechafin);
  }
  //Revisa cambios en la ubicación
  function onChangesUbicacion(e, index, list) {
    const { name, value } = e.target;
    //Si corresponde la misma ubicación y estatus para todos los registros.
    if (mEstatusUbicacion === true && (name === "status" || name === "ubicacion")) {
      list.map((recibau, i) => {
        list[i][name] = value;
        if (name === "status" || name === "ubicacion") {
          if (
            list[i].ubicacion === "Almacén" &&
            list[i].locacion !== "" &&
            list[i].locacion !== list[i].locacionOriginal
          ) {
            //Se revisa si se libera la locación cuando el materian se encuentra en Caja
            if (list[i].materialEn === "Caja") {
              const llocacion = list.filter(
                (reciba) =>
                  reciba.lote === list[i].lote &&
                  reciba.materialEn === "Caja" &&
                  reciba.ubicacion === "Almacén" &&
                  reciba.locacion !== list[i].locacion
              );
              //Si existen más registros de material en cajas del mismo lote.
              if (llocacion.length === 1) {
                //Se revisa si hay diferentes locaciones asignadas.
                const locacionae = locacionesSinFiltro.filter(
                  (locacion) => locacion.locacion === list[i].locacion
                );
                if (locacionae[0]) {
                  liberarlocacion(locacionae[0]);
                }
              }
            }
          }
        }
        if (name === "status") {
          if (value === "En reciba") list[i].ubicacion = "Reciba";

          if (value === "Rechazado") list[i].ubicacion = "Cuarentena";

          list[i].locacion = "";

          if (value === "Aceptado") {
            list[i].ubicacion = "Almacén";
            //Revisando si el material se encuentra en cajas y si ya hay una locación asignada, para asignarla
            if (list[i].materialEn === "Caja") {
              const llocacion = list.filter(
                (reciba) =>
                  reciba.lote === list[i].lote &&
                  reciba.materialEn === "Caja" &&
                  reciba.ubicacion === "Almacén" &&
                  reciba.locacion !== ""
              );
              //Si existen más registros de material en cajas del mismo lote.
              var nlocacion = 0;
              var clocacion = "";
              var elocacion = 0;
              if (llocacion.length > 0) {
                //Se revisa si hay diferentes locaciones asignadas.
                llocacion.map((rlocacion) => {
                  if (rlocacion.locacion !== clocacion) {
                    clocacion = rlocacion.locacion;
                    elocacion = rlocacion.espacioOcupado;
                    nlocacion++;
                  }
                });
                //Si solo hay una locacion asignada, se asigna esa locación
                if (nlocacion === 1) {
                  list[i].locacion = clocacion;
                  list[i].espacioOcupado = elocacion;
                }
              }
            }
          }
        }
        if (name === "ubicacion") {
          list[i].locacion = value === "Producción" ? "Carga" : "";
          if (value === "Almacén") {
            //Revisando si el material se encuentra en cajas y si ya hay una locación asignada, para asignarla
            if (list[i].materialEn === "Caja") {
              const llocacion = list.filter(
                (reciba) =>
                  reciba.lote === list[i].lote &&
                  reciba.materialEn === "Caja" &&
                  reciba.ubicacion === "Almacén" &&
                  reciba.locacion !== ""
              );
              //Si existen más registros de material en cajas del mismo lote.
              var nlocacion = 0;
              var clocacion = "";
              var elocacion = 0;
              if (llocacion.length > 0) {
                //Se revisa si hay diferentes locaciones asignadas.
                llocacion.map((rlocacion) => {
                  if (rlocacion.locacion !== clocacion) {
                    clocacion = rlocacion.locacion;
                    elocacion = rlocacion.espacioOcupado;
                    nlocacion++;
                  }
                });
                //Si solo hay una locacion asignada, se asigna esa locación
                if (nlocacion === 1) {
                  list[i].locacion = clocacion;
                  list[i].espacioOcupado = elocacion;
                }
              }
            }
          }
        }
        return recibau;
      });

    } else if (name === "status" || name === "ubicacion") {//Si no corresponde la misma ubicación y estatus para todos los registros.       
      if (name === "status" || name === "ubicacion") {
        if (
          list[index].ubicacion === "Almacén" &&
          list[index].locacion !== "" &&
          list[index].locacion !== list[index].locacionOriginal
        ) {
          //Se revisa si se libera la locación cuando el materian se encuentra en Caja
          if (list[index].materialEn === "Caja") {
            const llocacion = list.filter(
              (reciba) =>
                reciba.lote === list[index].lote &&
                reciba.materialEn === "Caja" &&
                reciba.ubicacion === "Almacén" &&
                reciba.locacion !== list[index].locacion
            );
            //Si existen más registros de material en cajas del mismo lote.
            if (llocacion.length === 1) {
              //Se revisa si hay diferentes locaciones asignadas.
              const locacionae = locacionesSinFiltro.filter(
                (locacion) => locacion.locacion === list[index].locacion
              );
              if (locacionae[0]) {
                liberarlocacion(locacionae[0]);
              }
            }
          }
        }
      }
      if (name === "status") {
        if (value === "En reciba") list[index].ubicacion = "Reciba";

        if (value === "Rechazado") list[index].ubicacion = "Cuarentena";

        list[index].locacion = "";

        if (value === "Aceptado") {
          list[index].ubicacion = "Almacén";
          //Revisando si el material se encuentra en cajas y si ya hay una locación asignada, para asignarla
          if (list[index].materialEn === "Caja") {
            const llocacion = list.filter(
              (reciba) =>
                reciba.lote === list[index].lote &&
                reciba.materialEn === "Caja" &&
                reciba.ubicacion === "Almacén" &&
                reciba.locacion !== ""
            );
            //Si existen más registros de material en cajas del mismo lote.
            var nlocacion = 0;
            var clocacion = "";
            var elocacion = 0;
            if (llocacion.length > 0) {
              //Se revisa si hay diferentes locaciones asignadas.
              llocacion.map((rlocacion) => {
                if (rlocacion.locacion !== clocacion) {
                  clocacion = rlocacion.locacion;
                  elocacion = rlocacion.espacioOcupado;
                  nlocacion++;
                }
              });
              //Si solo hay una locacion asignada, se asigna esa locación
              if (nlocacion === 1) {
                list[index].locacion = clocacion;
                list[index].espacioOcupado = elocacion;
              }
            }
          }
        }
      }
      if (name === "ubicacion") {
        list[index].locacion = value === "Producción" ? "Carga" : "";
        if (value === "Almacén") {
          //Revisando si el material se encuentra en cajas y si ya hay una locación asignada, para asignarla
          if (list[index].materialEn === "Caja") {
            const llocacion = list.filter(
              (reciba) =>
                reciba.lote === list[index].lote &&
                reciba.materialEn === "Caja" &&
                reciba.ubicacion === "Almacén" &&
                reciba.locacion !== ""
            );
            //Si existen más registros de material en cajas del mismo lote.
            var nlocacion = 0;
            var clocacion = "";
            var elocacion = 0;
            if (llocacion.length > 0) {
              //Se revisa si hay diferentes locaciones asignadas.
              llocacion.map((rlocacion) => {
                if (rlocacion.locacion !== clocacion) {
                  clocacion = rlocacion.locacion;
                  elocacion = rlocacion.espacioOcupado;
                  nlocacion++;
                }
              });
              //Si solo hay una locacion asignada, se asigna esa locación
              if (nlocacion === 1) {
                list[index].locacion = clocacion;
                list[index].espacioOcupado = elocacion;
              }
            }
          }
        }
      }
    }
    //Si corresponden los mismos datos de Inspección.
    if (mDatosInspeccion === true && (name === "empaqueSinDanos" || name === "materialCorrecto" ||
      name === "materialNContaminado" || name === "materialSinDefectosOvios" || name === "espesor"
      || name === "pruebaSolubilidad")) {
      list.map((recibau, i) => {
        list[i][name] = value;
        return recibau;
      });
    }
    list[index][name] = value;
    return list;
  }
  function onChangesFechaUbicacion(e, index, list) {
    const { name, value } = e.target;
    list[index][name] = value;
    return list;
  }
  //Revisa cambios en Material
  async function onChangeCliente(e) {
    setCargando(true);
    const clienteFromAPI = clientes.filter(
      (cliente) => cliente.id === e.target.value
    );
    await Promise.all(
      clienteFromAPI.map(async (cliente) => {
        updateFormData(() => ({
          ...formData,
          [e.target.name]: e.target.value,
          cliente: cliente.cliente,
        }));
      })
    );
    //Se obtiene los datos de los productos
    if (e.target.value) fetchProductos(e.target.value);
    inputList.map((series) => {
      if (clienteFromAPI[0].cliente === "Olson Internacional") {
        if (series.lote === "ND") {
          series.lote = "";
        }
        setAgregarLoteFaltante(false);
      } else {
        setAgregarLoteFaltante(true);
        if (series.lote === "") {
          series.lote = "ND";
        }
      }
      series.parteValido = false;
      series.productoID = "";
      series.numerodeParte = "";
      series.descripcion = "";
    });
    let filter = {
      and: [
        {
          activo: {
            eq: true
          }
        }, {
          clienteID: {
            eq: e.target.value
          }
        },
        {
          fechaDeReciba: {
            ge: fdias
          }
        },
        {
          fechaDeReciba: {
            le: fhoy
          }
        },]
    };
    //Obteniendo los datos de los seriales/contenedores
    const recibas = await GetReciba(filter);
    var recibaSerialesID = [];
    await Promise.all(
      recibas.map(async (reciba) => {
        recibaSerialesID = [...recibaSerialesID, ...reciba.serialesID]
      })
    );
    //setNFocus(JSON.stringify(recibaSerialesID));
    const dataSeriales = recibaSerialesID.length > 0 ? await ObtenerSeriales(recibaSerialesID) : [];//await GetRecibaSeriales(filter);
    setSerialesRepetidos(dataSeriales);
    var list = inputList;
    list.map((dserial) => {
      if (dserial.serial === "ND") {
        dserial.serialDuplicado = false;
      } else {
        const flist = inputList.filter(
          (drecibaf) => drecibaf.serial === dserial.serial
        );
        const rlist = dataSeriales.filter((dreciba) => dreciba.serial == dserial.serial
        );

        if ((flist.length > 1) || (rlist.length > 0)) {
          dserial.serialDuplicado = true;
        } else {
          dserial.serialDuplicado = false;
        }
      }
      return dserial;
    });
    setInputList(list);
    setCargando(false);
  }
  // handle input change
  function handleInputChangePacking(e, index, list) {
    const { name, value } = e.target;
    inputList.map((seriales) => {
      if (seriales.packingindex === list[index].packingindex) {
        seriales.packing = value;
      }
    });
    list[index][name] = value;
    return list;
  }
  // handle input change
  function handleInputChangePO(e, index, list) {
    const { name, value } = e.target;
    inputList.map((seriales) => {
      if (seriales.packingindex === list[index].packingindex) {
        seriales.po = value;
      }
    });
    list[index][name] = value;
    return list;
  }
  function concatenarPackings(list) {
    var packings = "";
    list.map((packing, i) => {
      if (i === 0) packings = packing.packing;
      else packings = packings + ", " + packing.packing;
    });
    return packings;
  }
  function concatenarPos(list) {
    var pos = "";
    var po = "";
    const listPO = list.sort((a, b) =>
      a.po > b.po ? 1 : a.po < b.po ? -1 : 0
    );
    listPO.map((packing, i) => {
      if (i === 0) {
        pos = packing.po;
        po = packing.po;
      } else {
        if (packing.po !== po) {
          pos = pos + ", " + packing.po;
          po = packing.po;
        }
      }
      return packing;
    });
    return pos;
  }
  function concatenarLotes(list) {
    const serialesreciba = list.sort((a, b) =>
      a.lote < b.lote ? 1 : a.lote > b.lote ? -1 : 0
    );
    var lote = "";
    var lotes = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (lote !== serial.lote) {
          if (i === 0) lotes = serial.lote;
          else lotes = lotes + ", " + serial.lote;
          lote = serial.lote;
        }
      }
    });
    return lotes;
  }
  function concatenarDescripciones(list) {
    const serialesreciba = list.filter(serial => serial.descripcion !== "").sort((a, b) =>
      a.descripcion < b.descripcion ? 1 : a.descripcion > b.descripcion ? -1 : 0
    );
    var descripcion = "";
    var descripciones = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (descripcion !== serial.descripcion) {
          if (i === 0) descripciones = serial.descripcion;
          else descripciones = descripciones + ", " + serial.descripcion;
          descripcion = serial.descripcion;
        }
      }
    });
    return descripciones;
  }
  function ObtenerContenedores(list) {
    var contenedores = 0;
    var cajas = 0;
    list.map((recibadf, i) => {
      if (recibadf.activo === true && recibadf.ultimoxpacking === false) {
        contenedores =
          contenedores +
          (recibadf.materialEn === "Contenedor"
            ? parseInt(recibadf.materialEnCantidad)
            : 0);
        cajas =
          cajas +
          (recibadf.materialEn === "Caja"
            ? parseInt(recibadf.materialEnCantidad)
            : 0);
      }
    });
    const CajasContenedores =
      (contenedores > 0 ? contenedores + " Contenedores" : "") +
      (cajas > 0
        ? (contenedores > 0 ? ", " : "") + cajas + " Cajas"
        : "");
    return CajasContenedores;
  }
  function concatenarNumerosdeParte(list) {
    const serialesreciba = list.sort((a, b) =>
      a.numerodeParte < b.numerodeParte
        ? 1
        : a.numerodeParte > b.numerodeParte
          ? -1
          : 0
    );
    var numerodeParte = "";
    var numerosdeParte = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (numerodeParte !== serial.numerodeParte) {
          if (i === 0) numerosdeParte = serial.numerodeParte;
          else numerosdeParte = numerosdeParte + ", " + serial.numerodeParte;
          numerodeParte = serial.numerodeParte;
        }
      }
    });
    return numerosdeParte;
  }
  function concatenarSerialresID(list) {
    const serialesreciba = list.sort((a, b) =>
      a.numerodeParte < b.numerodeParte
        ? 1
        : a.numerodeParte > b.numerodeParte
          ? -1
          : 0
    );
    var serialID = "";
    var serialesID = [];
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (serialID !== serial.id) {
          serialesID.push({ id: serial.id })
        }
      }
    });
    return serialesID;
  }
  function concatenarSeriales(list) {
    const serialesreciba = list.sort((a, b) =>
      a.serial < b.serial ? 1 : a.serial > b.serial ? -1 : 0
    );
    var cseriale = "";
    var seriales = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (cseriale !== serial.serial) {
          if (i === 0) seriales = serial.serial;
          else seriales = seriales + ", " + serial.serial;
          cseriale = serial.serial;
        }
      }
    });
    return seriales;
  }
  function concatenarSerialesBTI(list) {
    const serialesreciba = list.sort((a, b) =>
      a.serialRecibaBTI < b.serialRecibaBTI ? 1 : a.serialRecibaBTI > b.serialRecibaBTI ? -1 : 0
    );
    var cseriale = "";
    var seriales = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true && serial.ultimoxpacking === false) {
        if (cseriale !== serial.serialRecibaBTI) {
          if (i === 0) seriales = serial.serialRecibaBTI;
          else seriales = seriales + ", " + serial.serialRecibaBTI;
          cseriale = serial.serialRecibaBTI;
        }
      }
    });
    return seriales;
  }
  //Guarda los datos de Reciba
  async function guardarReciba() {
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    const faltanDatos = faltanDatosF(inputList);
    formData.cantidadRecibida = cantidadRecibidaS(inputList);
    try {
      delete formData.indexpag;
      if (
        !formData.clienteID ||
        !formData.fechaDeReciba ||
        !formData.horaDeReciba ||
        !formData.cliente ||
        !formData.cantidadRecibida ||
        !formData.status ||
        faltanDatos === true
      ) {
        setMensajeAlert(
          "Faltan datos o son inválidos: los campos marcados con un asterisco son obligatorios, los números de parte inválidos y los números de serie repetidos se marcan en rojo"
        );
        /*setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios, Cantidad " +
                    formData.cantidadRecibida + " Faltan datos " + faltanDatos);*/
        setFaltanDatos(true);
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);
      } else {
        if (
          Moment(now).format("DD/MM/YYYY") <
          Moment(formData.fechaDeReciba).format("DD/MM/YYYY")
        ) {
          setMensajeAlert(
            "La fecha de reciba no debe ser mayor al día de hoy, favor de verificar"
          );
          setColor("warning");
          setCargando(false);
          setAVisible(true);
          window.scrollTo(0, 0);
          setisDisabled(false);
          /*}else if (Moment(now).format("DD/MM/YYYY")<Moment(inputUbicaciones[0].fechaIngreso).format("DD/MM/YYYY")){
                        setMensajeAlert("La fecha de ubicación no debe ser mayor al día de hoy, favor de verificar" );
                        setColor("warning");
                        setAVisible(true);
                        window.scrollTo(0, 0);
                        setisDisabled(false);*/
        } else {
          //Obteniendo el número de ID de reciba
          const totalaGuardar = inputList.filter(
            (serial) => serial.ultimoxpacking === false
          );
          var numeroUP = 1;
          var serialRecibaBTI = totalaGuardar.length;
          var RnumeroSerial = 0;
          const apiData = await API.graphql({
            query: listRecibaUltimoNumeros,
            variables: { limit: 100000000 },
          });
          const ultimarFromAPI = apiData.data.listRecibaUltimoNumeros.items;
          await Promise.all(
            ultimarFromAPI.map(async (ultimonumeroreciba) => {
              RnumeroSerial = parseFloat(
                ultimonumeroreciba.serialRecibaBTI
                  ? ultimonumeroreciba.serialRecibaBTI
                  : 0
              );
              numeroUP = ultimonumeroreciba.numero + 1;
              ultimonumeroreciba.numero = numeroUP;
              ultimonumeroreciba.serialRecibaBTI =
                RnumeroSerial + serialRecibaBTI;

              delete ultimonumeroreciba.createdAt;
              delete ultimonumeroreciba.updatedAt;
              delete ultimonumeroreciba.__typename;
              ultimonumeroreciba.Reg_Mod_Usuario = userName;
              await API.graphql({
                query: updateRecibaUltimoNumero,
                variables: { input: ultimonumeroreciba },
              });

              return ultimonumeroreciba;
            })
          );
          if (!ultimarFromAPI.length) {
            await API.graphql({
              query: createRecibaUltimoNumero,
              variables: {
                input: {
                  numero: numeroUP,
                  activo: true,
                  Reg_Ins_Usuario: userName,
                  serialRecibaBTI: serialRecibaBTI,
                },
              },
            });
          }
          //Se determina el DUE DATE
          var nowrf = new Date(formData.fechaDeReciba);
          nowrf.setDate(nowrf.getDate() + 3);
          //Se determina el loteBTI { and: [{ activo: { eq: true } }, { fechaDeReciba: { eq: formData.fechaDeReciba } }] }
          /*var recibaPD = await GetReciba({ fechaDeReciba: { eq: formData.fechaDeReciba } });
          const cn = (recibaPD.length ? recibaPD.length : 0) + 1;
          const loteBTI =
            (formData.cliente.toUpperCase().substring(0, 2)) +
            Moment(formData.fechaDeReciba).format("MMDDYY") +
            formData.horaDeReciba.replace(":", "") +
            "-" +
            (cn < 10 ? "00" + cn : cn < 100 ? "0" + cn : cn);*/
          //Guarda los datos de la reciba
          formData.numero =
            numeroUP < 10
              ? "R00" + numeroUP.toString()
              : numeroUP < 100
                ? "R0" + numeroUP.toString()
                : "R" + numeroUP.toString();
          formData.packings = concatenarPackings(inputListPacking);
          formData.po = concatenarPos(inputListPacking);
          formData.numerosdeParte = concatenarNumerosdeParte(inputList);
          formData.lotes = concatenarLotes(inputList);
          formData.seriales = concatenarSeriales(inputList);
          formData.dueDate = Moment(nowrf).format("DD-MM-YYYY");
          //formData.LoteBTI = loteBTI;
          formData.descripcionesNP = concatenarDescripciones(inputList);
          formData.contenedores = ObtenerContenedores(inputList);
          let resultadoc = await API.graphql({
            query: createRecibaMutation,
            variables: { input: formData },
          });
          //Datos recién creados.
          const recibaCreada = resultadoc.data.createReciba;
          //Equivalente en letra del año.
          const Anio = Moment(new Date()).format("YYYY");
          var aLetra = "AA";
          const anioLetra = aniosLetra.filter((anio) => anio.año == Anio);
          if (anioLetra[0]) aLetra = anioLetra[0].letra;

          //Equivalente del mes en número.
          const lmes = Moment(new Date()).format("MM");
          var mNumero = "0";
          const mesesNumeros = mesNumero.filter((nmes) => nmes.mes === lmes);
          if (mesesNumeros[0]) mNumero = mesesNumeros[0].numero;

          //setMensajeAlert("Error con la creación; " + JSON.stringify(recibaCreada));
          if (recibaCreada.id) {
            var serialesBTI = "";
            var serialesID = [];
            await Promise.all(
              inputList.map(async (serial, i) => {
                if (serial.ultimoxpacking === false) {
                  RnumeroSerial = RnumeroSerial + 1;

                  const SerialRecibaBTI =
                    "BTI-" +
                    aLetra +
                    mNumero +
                    "-" +
                    (RnumeroSerial < 10
                      ? "0000" + RnumeroSerial.toString()
                      : RnumeroSerial < 100
                        ? "000" + RnumeroSerial.toString()
                        : RnumeroSerial < 1000
                          ? "00" + RnumeroSerial.toString()
                          : RnumeroSerial < 10000
                            ? "0" + RnumeroSerial.toString()
                            : RnumeroSerial.toString()) + "-" +
                    (serial.Ecoat === true ? "E" : "") +
                    (serial.Pcoat === true ? "P" : "");
                  const numerodeParteSalida = await GetProductosID(serial.productoID);//productos.filter((producto) => producto.productoID === serial.productoID);
                  if (numerodeParteSalida.id) {
                    const sporNPV = numerodeParteSalida.sporNP ? numerodeParteSalida.sporNP : false;
                    serial.numerodeParte = numerodeParteSalida.numerodeParte;
                    serial.numerodeParteSalida = numerodeParteSalida.numerodeParteSalida;
                    serial.poEmbarques = numerodeParteSalida.poEmbarques;
                    serial.sporNP = sporNPV;
                    serial.krecibaNP = sporNPV ? "NP&" + formData.numero.toUpperCase() + "-" + serial.numerodeParte.toUpperCase() : "";
                  }
                  serial.Reg_Ins_Usuario = userName;
                  delete serial.manual;
                  delete serial.parteValido;
                  delete serial.ultimoxpacking;
                  delete serial.primeroxpacking;
                  delete serial.fid;
                  delete serial.serialDuplicado;
                  delete serial.recibaSerialMPID;
                  serial.serialRecibaBTI = SerialRecibaBTI;
                  serial.recibaID = recibaCreada.id;
                  serial.numero = formData.numero;
                  serial.cliente = formData.cliente;
                  serial.clienteID = formData.clienteID;
                  serial.fechaDeReciba = formData.fechaDeReciba;
                  serial.piezasEnPlanta = true;
                  serial.cantidadRecibidaOriginal = serial.cantidadRecibida;
                  //serial.po = formData.po;
                  serial.fechayHoraDeReciba =
                    Moment(formData.fechaDeReciba).format("DD/MM/YYYY") +
                    " " +
                    formData.horaDeReciba;
                  serial.cantidadporParte = cantidadRecibidaxParte(
                    inputList,
                    i
                  );
                  //Se crean los datos en recibaSerialesMP
                  setMensajeAlert(
                    "Problemas al guardar los datos de la reciba MP 1: " +
                    JSON.stringify(serial)
                  );
                  //Se crean los datos en recibaSerialesMP
                  let serialesMP = await API.graphql({
                    query: createRecibaSerialesMP,
                    variables: { input: serial },
                  });
                  //Se obtienen los datos de recibaSerialesMP recién creados
                  const recibaMPCreada = serialesMP.data.createRecibaSerialesMP;
                  setMensajeAlert(
                    "Problemas al guardar los datos de la reciba 1: " +
                    JSON.stringify(serial)
                  );
                  //Se crea los datos en recibaSeriales
                  let resultadocs = await API.graphql({
                    query: createRecibaSeriales,
                    variables: { input: { ...serial, recibaSerialMPID: recibaMPCreada.id } },
                  });

                  //Datos recién creados en recibaSeriales.
                  var recibasCreada = resultadocs.data.createRecibaSeriales;
                  recibaMPCreada.recibaSerialID = recibasCreada.id;
                  recibaMPCreada.rsUpdatedAt = recibasCreada.updatedAt;
                  //Actualiza el id creado en reciba seriales
                  delete recibaMPCreada.updatedAt;
                  delete recibaMPCreada.createdAt;
                  delete recibaMPCreada.__typename;
                  await API.graphql({
                    query: updateRecibaSerialesMP,
                    variables: { input: recibaMPCreada },
                  });

                  serialesBTI = serialesBTI === "" ? SerialRecibaBTI : serialesBTI + "," + SerialRecibaBTI;
                  serialesID.push({ id: recibasCreada.id });
                }
              })
            );
            //Se actualiza el dato de seralRecibaBTI en Reciba.
            if (recibaCreada.id) {
              recibaCreada.serialesBTI = serialesBTI;
              recibaCreada.serialesID = serialesID;
              delete recibaCreada.createdAt;
              delete recibaCreada.updatedAt;
              delete recibaCreada.__typename;
              setMensajeAlert(
                "Problemas al actualizar los datos de la reciba 2: " +
                JSON.stringify(recibaCreada)
              );
              await API.graphql({
                query: updateRecibaMutation,
                variables: { input: recibaCreada },
              });
            }
            //Se guardan los datos en Resumen de operacion

            recibaCreada.recibaSerialID = recibaCreada.serialesID;
            const rOperacion = await manageResumenOperacion(formData.fechaDeReciba, recibaCreada, "Reciba", userName, recibaCreada.id);
            // setMensajeAlert("Reciba creada con éxito" + JSON.stringify(rOperacion));
          }
          setMensajeAlert("Reciba creada con éxito");
          setColor("primary");
          setCargando(false);
          setAVisible(true);
          window.scrollTo(0, 0);
          setRfechaini(now2);
          setRfechafin(now);
          await fetchReciba(now2, now);
          preciba();
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar ");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      setisDisabled(false);
    }
  }
  //Actualiza los datos de la reciba
  async function updateReciba() {
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    const datosSerial = await cambioSerial(inputList);
    const modificados = datosSerial.filter(serial => serial.modificado === true);
    const faltanDatos = faltanDatosF(inputList);
    formData.cantidadRecibida = cantidadRecibidaS(inputList);
    try {
      if (
        !formData.clienteID ||
        !formData.fechaDeReciba ||
        !formData.horaDeReciba ||
        !formData.cliente ||
        !formData.cantidadRecibida ||
        !formData.status ||
        faltanDatos === true
      ) {
        setMensajeAlert(
          "Faltan datos o son inválidos: los campos marcados con un asterisco son obligatorios, los números de parte inválidos y los números de serie repetidos se marcan en rojo"
        );
        /*setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios, Cantidad " +
                    formData.cantidadRecibida + " Faltan datos " + faltanDatos);*/
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);
      } else if (Date.parse(now) < Date.parse(formData.fechaDeReciba)) {
        setMensajeAlert(
          "La fecha de reciba no debe ser mayor al día de hoy, favor de verificar"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);
        /*}else if (Date.parse(now)<Date.parse(inputUbicaciones[0].fechaIngreso)){
                    setMensajeAlert("La fecha de ubicación no debe ser mayor al día de hoy, favor de verificar" );
                    setColor("warning");
                    setAVisible(true);
                    window.scrollTo(0, 0);
                    setisDisabled(false); */
      } else {
        if (modificados.length > 0) {
          //Se revisa si hay concurrencia.
          let filter = {
            numero: {
              eq: formData.numero,
            },
          };
          //Se declaran variables auxiliar para revisar la concurrencia y si el material ya fue planificado.
          var concurrencia = false;
          var planificado = false;
          var ubicacionE = false;
          //Se obtienen todos los seriales de la reciba en cuestión
          const recibaFromAPI = await ObtenerSeriales(formData.serialesID);//GetRecibaSeriales(filter);
          //Se revisa que ninguno de los contenedores de la reciba se haya planificado ya
          //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación
          await Promise.all(
            recibaFromAPI.map(async (recibaSerial) => {
              //Se revisa si hay concurrencia
              const recibasf = modificados.filter((rserialessf) => rserialessf.id === recibaSerial.id);
              if (recibasf.length > 0) {
                if (recibaSerial.updatedAt !== recibasf[0].updatedAt)
                  concurrencia = true;
              }
              //Se revisa si los registros marcados como activo = a falsó ya fueron planificados
              const recibafalse = modificados.filter((recibasfalse) => recibasfalse.id === recibaSerial.id &&
                (recibaSerial.cantidadPlaneada > 0 || (recibaSerial.piezasEmbarcadas ? recibaSerial.piezasEmbarcadas : 0) > 0) /*&& recibasfalse.activo === false*/);
              //Se revisa que algún contenedor de la reciba ya fue planificado
              if (recibafalse[0]) {
                planificado = true;
              }
              /*if (recibaSerial.rubicaciones) {
                if (recibaSerial.rubicaciones.length > 1) {
                  ubicacionE = true;
                }
              }*/
            })
          );
          if (planificado) {
            window.scrollTo(0, 0);
            setMensajeAlert(
              "No fue posible realizar la operación: uno o más registros que se intentan eliminar o modificar, ya se encuentran planificados o total o parcialmente embarcado"
            );
          }
          //Se revisa si existe más de un registro de ubicación del material
          /* if (ubicacionE) {
             window.scrollTo(0, 0);
             setMensajeAlert(
               "No fue posible realizar la operación: uno o más registros que se intentan modificar tienen más de un registro de ubicación en el sistema "
             );
             setColor("warning");
             setCargando(false);
             setAVisible(true);
             return;
           }*/

          //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación
          if (concurrencia === false) {
            const packings = concatenarPackings(inputListPacking);
            const pos = concatenarPos(inputListPacking);
            const numerosdeParte = concatenarNumerosdeParte(inputList);
            const lotes = concatenarLotes(inputList);
            const seriales = concatenarSeriales(inputList);
            const descripcionesNP = concatenarDescripciones(inputList);
            const contenedores = ObtenerContenedores(inputList);

            var serialesBTI = "";
            var serialesID = [];
            if (formData.activo === false) {
              //const seriales = recibaSerialesSinFiltro;
              await Promise.all(
                recibaSerialesSinFiltro.map(async (serial, i) => {
                  if (serial.activo === true && serial.recibaID !== "") {
                    delete serial.createdAt;
                    delete serial.updatedAt;
                    delete serial.__typename;
                    delete serial.locacionOriginal;
                    delete serial.ubicacionOriginal;
                    delete serial.statusOriginal;
                    delete serial.scolor;
                    delete serial.serialDuplicado;
                    delete serial.modificado;
                    serial.activo = formData.activo;
                    serial.piezasEnPlanta = false;
                    serial.Reg_Mod_Usuario = userName;
                    await API.graphql({
                      query: updateRecibaSeriales,
                      variables: { input: serial },
                    });
                    if (serial.recibaSerialMPID) {
                      //Se actualizan los datos en la tabla de serialesMP
                      setMensajeAlert("No se pudieron eliminar los datos de la reciba temporal; ");
                      await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: serial.recibaSerialMPID, } } });
                    }
                  }
                })
              );
            } else {
              //Se revisa si se agregaron registros, si es así, se tienen que generar los Seriales BTI correspondientes
              const totalaGuardar = inputList.filter(
                (serial) => serial.ultimoxpacking === false && serial.recibaID === "");
              //Si existen nuevos datos, se actualiza en la tabla RecibaUltimoNumero el último número en serialRecibaBTI
              if (totalaGuardar[0]) {
                var serialRecibaBTI = totalaGuardar.length;
                var RnumeroSerial = 0;
                //Se obtiene el último dato de serialRecibaBTI
                const apiData = await API.graphql({
                  query: listRecibaUltimoNumeros,
                  variables: { limit: 100000000 },
                });
                const ultimarFromAPI =
                  apiData.data.listRecibaUltimoNumeros.items;
                //Se actualiza en la tabla el último dato de serialRecibaBTI
                await Promise.all(
                  ultimarFromAPI.map(async (ultimonumeroreciba) => {
                    RnumeroSerial = parseFloat(
                      ultimonumeroreciba.serialRecibaBTI
                        ? ultimonumeroreciba.serialRecibaBTI
                        : 0
                    );
                    ultimonumeroreciba.serialRecibaBTI =
                      RnumeroSerial + serialRecibaBTI;

                    delete ultimonumeroreciba.createdAt;
                    delete ultimonumeroreciba.updatedAt;
                    delete ultimonumeroreciba.__typename;
                    ultimonumeroreciba.Reg_Mod_Usuario = userName;
                    await API.graphql({
                      query: updateRecibaUltimoNumero,
                      variables: { input: ultimonumeroreciba },
                    });
                    return ultimonumeroreciba;
                  })
                );
                //Equivalente en letra del año.
                const Anio = Moment(new Date()).format("YYYY");
                var aLetra = "AA";
                const anioLetra = aniosLetra.filter((anio) => anio.año == Anio);
                if (anioLetra[0]) aLetra = anioLetra[0].letra;

                //Equivalente del mes en número.
                const lmes = Moment(new Date()).format("MM");
                var mNumero = "0";
                const mesesNumeros = mesNumero.filter(
                  (nmes) => nmes.mes == lmes
                );
                if (mesesNumeros[0]) mNumero = mesesNumeros[0].numero;
              }
              //Se  crea o actualizan los datos de la reciba seriales según corresponda
              await Promise.all(
                inputList.map(async (serial, i) => {
                  if (serial.ultimoxpacking === false) {
                    const numerodeParteSalida = await GetProductosID(serial.productoID);//productos.filter((producto) => producto.productoID === serial.productoID);
                    if (numerodeParteSalida.id) {
                      const sporNPV = numerodeParteSalida.sporNP ? numerodeParteSalida.sporNP : false;
                      serial.numerodeParte = numerodeParteSalida.numerodeParte;
                      serial.numerodeParteSalida = numerodeParteSalida.numerodeParteSalida;
                      serial.poEmbarques = numerodeParteSalida.poEmbarques;
                      serial.sporNP = sporNPV;
                      serial.krecibaNP = sporNPV ? ("NP&" + formData.numero.toUpperCase() + "-" + serial.numerodeParte.toUpperCase()) : "";
                    }
                    delete serial.manual;
                    delete serial.parteValido;
                    delete serial.ultimoxpacking;
                    delete serial.primeroxpacking;
                    delete serial.fid;
                    delete serial.modificado;
                    delete serial.serialDuplicado;
                    //Si no existe el registro del serial en cuestión, se crea
                    if (serial.recibaID === "") {
                      if (serial.activo === true) {
                        //Se obtiene el serial BTI que corresponde a cada registro.
                        RnumeroSerial = RnumeroSerial + 1;
                        formData.status = "En reciba";
                        const SerialRecibaBTI =
                          "BTI-" +
                          aLetra +
                          mNumero +
                          "-" +
                          (RnumeroSerial < 10
                            ? "0000" + RnumeroSerial.toString()
                            : RnumeroSerial < 100
                              ? "000" + RnumeroSerial.toString()
                              : RnumeroSerial < 1000
                                ? "00" + RnumeroSerial.toString()
                                : RnumeroSerial < 10000
                                  ? "0" + RnumeroSerial.toString()
                                  : RnumeroSerial.toString()) + "-" +
                          (serial.Ecoat === true ? "E" : "") +
                          (serial.Pcoat === true ? "P" : "");

                        serial.recibaID = formData.id;
                        serial.numero = formData.numero;
                        serial.serialRecibaBTI = SerialRecibaBTI;
                        serial.cliente = formData.cliente;
                        serial.clienteID = formData.clienteID;
                        serial.fechaDeReciba = formData.fechaDeReciba;
                        serial.piezasEnPlanta = true;
                        serial.cantidadRecibidaOriginal = serial.cantidadRecibida;
                        //serial.po = formData.po;
                        serial.fechayHoraDeReciba =
                          Moment(formData.fechaDeReciba).format("DD/MM/YYYY") +
                          " " +
                          formData.horaDeReciba;

                        //Se crean los datos en recibaSerialesMP
                        let serialesMP = await API.graphql({
                          query: createRecibaSerialesMP,
                          variables: { input: serial },
                        });
                        //Se obtienen los datos de recibaSerialesMP recién creados
                        const recibaMPCreada = serialesMP.data.createRecibaSerialesMP;
                        setMensajeAlert(
                          "Problemas al guardar los datos de la reciba 1: " +
                          JSON.stringify({ ...serial, recibaSerialMPID: recibaMPCreada.id })
                        );
                        //Se crea los datos en recibaSeriales
                        let resultadocs = await API.graphql({
                          query: createRecibaSeriales,
                          variables: { input: { ...serial, recibaSerialMPID: recibaMPCreada.id } },
                        });

                        //Datos recién creados en recibaSeriales.
                        var recibasCreada = resultadocs.data.createRecibaSeriales;
                        recibaMPCreada.recibaSerialID = recibasCreada.id;
                        recibaMPCreada.rsUpdatedAt = recibasCreada.updatedAt;
                        //Actualiza el id creado en reciba seriales
                        delete recibaMPCreada.updatedAt;
                        delete recibaMPCreada.__typename;
                        delete recibaMPCreada.createdAt;
                        await API.graphql({
                          query: updateRecibaSerialesMP,
                          variables: { input: recibaMPCreada },
                        });
                        if (recibasCreada.id) {
                          serialesID.push({ id: recibasCreada.id });
                        }
                      }
                    } else {
                      const serialModificado = modificados.filter(serialm => serialm.id === serial.id);
                      if (serialModificado[0]) {
                        //Si existe el serial ya en la base de datos, se modifica.
                        const cantidadO = parseInt(serial.cantidadRecibidaOriginal ? serial.cantidadRecibidaOriginal : 0);
                        delete serial.createdAt;
                        delete serial.updatedAt;
                        delete serial.__typename;
                        delete serial.locacionOriginal;
                        delete serial.ubicacionOriginal;
                        delete serial.statusOriginal;
                        delete serial.scolor;
                        delete serial.fid;
                        delete serial.manual;
                        delete serial.parteValido;
                        delete serial.ultimoxpacking;
                        delete serial.primeroxpacking;
                        delete serial.serialDuplicado;
                        serial.numero = formData.numero;
                        serial.cliente = formData.cliente;
                        serial.clienteID = formData.clienteID;
                        serial.fechaDeReciba = formData.fechaDeReciba;
                        serial.cantidadRecibidaOriginal = serial.cantidadRecibida;
                        //serial.po = formData.po;
                        serial.fechayHoraDeReciba =
                          Moment(formData.fechaDeReciba).format("DD/MM/YYYY") +
                          " " +
                          formData.horaDeReciba;
                        //serial.recibaID=formData.id;
                        serial.Reg_Mod_Usuario = userName;
                        if (serial.status === "Aceptado" && serial.ubicacion === "Almacén") {
                          serial.piezasenAlmacen = serial.cantidadRecibida;
                          serial.cantidadporParte = cantidadRecibidaxParte(
                            inputList,
                            i
                          );
                        }
                        if (serial.rubicaciones && cantidadO !=
                          parseInt(serial.cantidadRecibida ? serial.cantidadRecibida : 0)) {
                          const ubicaciones = await ObtenerUbicaciones(serial.rubicaciones);
                          serial.rubicaciones = [{ ...ubicaciones[0], cantidad: serial.cantidadRecibida }];
                          serial.ultimaUbicacion = [{
                            ubicacion: ubicaciones[0].ubicacion,
                            locacion: ubicaciones[0].locacion,
                            cantidad: serial.cantidadRecibida,
                            espacio: ubicaciones[0].espacio
                          }];

                        }
                        let upRecibaS = await API.graphql({
                          query: updateRecibaSeriales,
                          variables: { input: serial },
                        });

                        if (serial.recibaSerialMPID) {
                          if (serial.activo === true) {
                            const serialMPID = serial.recibaSerialMPID;
                            //var serialMP = serial;
                            //serialMP.id = serial.recibaSerialMPID;
                            //serialMP.rsUpdatedAt = upRecibaS.data.updateRecibaSeriales.updatedAt;
                            delete serial.recibaSerialMPID;
                            await API.graphql({
                              query: updateRecibaSerialesMP,
                              variables: { input: { ...serial, id: serialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } },
                            });
                          } else {
                            //Se actualizan los datos en la tabla de serialesMP
                            setMensajeAlert("No se pudo eliminar el registro de la tabla temporal; ");
                            await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: serial.recibaSerialMPID, } } });
                          }

                        }
                      }
                    }
                    if (serial.activo === true) {
                      serialesBTI = serialesBTI === "" ? serial.serialRecibaBTI : serialesBTI + "," + serial.serialRecibaBTI;
                      if (serial.id) {
                        serialesID.push({ id: serial.id });
                      }
                    }
                  }

                })
              );

            }
            setMensajeAlert("Revisando seriales");
            if (serialesID.length < 0) {

              serialesID = concatenarSerialresID(inputList);
            }
            //Se actualizan los datos de la reciba
            delete formData.createdAt;
            delete formData.updatedAt;
            delete formData.__typename;
            delete formData.indexpag;
            formData.packings = packings;
            formData.po = pos;
            formData.numerosdeParte = numerosdeParte;
            formData.lotes = lotes;
            formData.seriales = seriales;
            formData.serialesBTI = serialesBTI;
            formData.serialesID = serialesID;
            formData.Reg_Mod_Usuario = userName;

            //Se determina el DUE DATE
            var nowrf = new Date(formData.fechaDeReciba);
            nowrf.setDate(nowrf.getDate() + 3);
            if (Moment(nowrf).format("DD-MM-YYYY") != formData.dueDate) {
              //Se determina el loteBTI { and: [{ activo: { eq: true } }, { fechaDeReciba: { eq: formData.fechaDeReciba } }] }
              /*var recibaPD = await GetReciba({ fechaDeReciba: { eq: formData.fechaDeReciba } });
              const cn = (recibaPD.length ? recibaPD.length : 0) + 1;
              const loteBTI =
                (formData.cliente.toUpperCase().substring(0, 2)) +
                Moment(formData.fechaDeReciba).format("MMDDYY") +
                formData.horaDeReciba.replace(":", "") +
                "-" +
                (cn < 10 ? "00" + cn : cn < 100 ? "0" + cn : cn);*/

              formData.dueDate = Moment(nowrf).format("DD-MM-YYYY");
              //formData.LoteBTI = loteBTI;
            }
            formData.descripcionesNP = descripcionesNP;
            formData.contenedores = contenedores;
            //delete formData.serialesb;
            setMensajeAlert("No se pudo actualizar el dato de la reciba general;" + JSON.stringify(formData));
            await API.graphql({
              query: updateRecibaMutation,
              variables: { input: formData },
            });
            //Se guardan los datos en Resumen de operacion
            formData.recibaSerialID = formData.serialesID;
            const rOperacion = await manageResumenOperacion(formData.fechaDeReciba, formData, "Reciba", userName, formData.id);
            //Si las operaciones salieron bien, se manda un mensaje de operación exitosa
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
            updateFormData(initialFormState);
            setisDisabled(false);
            fetchReciba();
            preciba();
          } else {
            //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
            window.scrollTo(0, 0);
            setMensajeAlert(
              "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
              " volver a intentarlo"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            fetchReciba();
          }
        } else {
          setMensajeAlert("No se detectaron cambios que realizar");
          setColor("primary");
          setCargando(false);
          setAVisible(true);
          updateFormData(initialFormState);
          setisDisabled(false);
          fetchReciba();
          preciba();
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      //updateFormData(initialFormState);

      /*  setMensajeAlert(
          "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
        );*/
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      setisDisabled(false);
    }
  }
  //Guarda los datos de Incomming
  async function guardarIncomming(individual) {
    //const auxinputlist = inputList;
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    if (individual === true) {
      toggle3();
    }
    try {
      const datosSerial = await cambioIncoming(inputList);
      const modificados = datosSerial.filter(serial => serial.modificado === true);
      const faltandatos = FaltanDatosUbicación(inputList);
      if (modificados.length > 0) {
        if (faltandatos === true) {
          setMensajeAlert(
            "Faltan datos o son inválidos: los campos marcados con un asterisco son obligatorios, las fechas de ubicación inválidas se marcan en rojo"
          );
          setColor("warning");
          setAVisible(true);
          setCargando(false);
          window.scrollTo(0, 0);
          setisDisabled(false);
        } else {
          setMensajeAlert("No faltan datos");
          //Se revisa si hay concurrencia.
          //Se obtienen los datos de la reciba
          const recibaFromAPI = await GetRecibaID(formData.id);
          //Si la fecha de actualización es la misma, no hay concurrencia y  se procede con la modificación
          //setMensajeAlert("Se obtuvo el id de la reciba: " + JSON.stringify(apiData));
          if (recibaFromAPI.updatedAt === formData.updatedAt) {
            //Se guardan los cambios
            var estadoReciba = false;
            var estadoRechazado = false;
            var estadoAceptado = false;
            var serialesNCU = "";
            var statusOriginal = "";
            var statusActual = "";
            //setMensajeAlert("Se revisó la concurrencia");         
            await Promise.all(
              inputList.map(async (serial, i) => {
                //Revisa el estatus de la reciba
                const recibaSerial = await GetRecibaSerialesID(serial.id);
                if (!recibaSerial.id) {
                  serialesNCU = serialesNCU + (serialesNCU === "" ? serial.serialRecibaBTI : (", " + serial.serialRecibaBTI))
                  return
                } else {
                  if (serial.updatedAt !== recibaSerial.updatedAt) {
                    serialesNCU = serialesNCU + (serialesNCU === "" ? serial.serialRecibaBTI : (", " + serial.serialRecibaBTI))
                    return
                  }
                }
                setMensajeAlert("Concurrencia revisada");
                //Se revisa concurrencia por serial
                if (serial.status === "En reciba") estadoReciba = true;
                if (serial.status === "Rechazado") estadoRechazado = true;
                if (serial.status === "Aceptado") estadoAceptado = true;
                if (
                  serial.locacionOriginal !== "" &&
                  serial.locacion !== serial.locacionOriginal
                ) {
                  const locacionae = locacionesSinFiltro.filter(
                    (locacion) => locacion.locacion === serial.locacionOriginal
                  );
                  if (locacionae[0]) {
                    await liberarlocacion(locacionae[0]);
                  }
                }
                setMensajeAlert("Iteracción: " + i);
                if (serial.status !== "En reciba") {
                  var ultimaUbicacion = [
                    {
                      ubicacion: serial.ubicacion,
                      locacion: serial.locacion,
                      cantidad: serial.cantidadRecibida,
                      espacio: serial.espacioOcupado,
                    },
                  ];
                }
                const snuevo = serial.nuevo;
                const seditar = serial.editar;
                const locacionOriginal = serial.locacionOriginal;
                const ubicacionOriginal = serial.ubicacionOriginal;
                if (individual === true) {
                  statusOriginal = serial.statusOriginal;
                  statusActual = serial.status;
                }
                setMensajeAlert("Datos de inicio obtenidos");
                // Se gurda en  ubicaciones obtienen los datos de la ubicación
                var ubicaciones = [];
                if ((serial.cantidadPlaneada ? serial.cantidadPlaneada : 0) === 0) {
                  if (snuevo === true && seditar === true) {
                    if (serial.status !== "En reciba") {

                      ubicaciones.push({
                        ubicacion: serial.ubicacion,
                        locacion: serial.locacion,
                        cantidad: serial.cantidadRecibida,
                        espacio: serial.espacioOcupado,
                        comentarios: serial.comentariosdeinspeccion ? serial.comentariosdeinspeccion : "",
                        ubicaciondeReciba: true,
                        activo: true,
                        orden: 1,
                        fechaIngreso: serial.fechaDeUbicacion,
                        horaIngreso: serial.horaDeUbicacion,
                        ultimo: true,
                        ultimoAnterior: 0,
                        fechaSalida: "",
                        horaSalida: ""
                      })

                    }
                    //Se guardan los datos de ubicación en el campo rubicaciones
                    serial.rubicaciones = ubicaciones;
                    serial.ultimaUbicacion = ultimaUbicacion;
                  } else {//Se liberan las locaciones originales si hubo cambios de locación
                    //Se actualizan los datos de ubicación si hubo cambios
                    if (
                      serial.locacion !== locacionOriginal ||
                      serial.ubicacion !== ubicacionOriginal
                    ) {
                      const dia = Moment(new Date()).format("YYYY-MM-DD");
                      const hora = Moment(new Date()).format("HH:mm");
                      //Se obtienen los datos de ubicación por id de reciba
                      const apiDataU = await ObtenerUbicaciones(serial.rubicaciones);
                      const rUbicacion = apiDataU.filter(
                        (ubicacion) =>
                          !ubicacion.fechaSalida || ubicacion.fechaSalida === null
                      );
                      //setMensajeAlert("Actualizando la ubicación: " + rUbicacion[0]);
                      //Se guardan los cambios en ubicación
                      var orden = 1;
                      await Promise.all(
                        apiDataU.map(async (ubicacion, i) => {
                          orden = i + 1;
                          if (!ubicacion.fechaSalida || ubicacion.fechaSalida === null || ubicacion.fechaSalida === "") {
                            ubicacion.fechaSalida = dia;
                            ubicacion.horaSalida = hora;
                          }
                          ubicaciones.push(ubicacion)
                        })
                      );

                      //Se crea la nueva ubicación
                      //setMensajeAlert("Editando la reciba");
                      if (serial.status !== "En reciba") {
                        ubicaciones.push({
                          ubicacion: serial.ubicacion,
                          locacion: serial.locacion,
                          cantidad: serial.cantidadRecibida,
                          espacio: serial.espacioOcupado,
                          comentarios: serial.comentariosdeinspeccion ? serial.comentariosdeinspeccion : "",
                          ubicaciondeReciba: true,
                          activo: true,
                          orden: apiDataU.length + 1,
                          fechaIngreso: dia,
                          horaIngreso: hora,
                          ultimo: true,
                          ultimoAnterior: apiDataU.length,
                          fechaSalida: "",
                          horaSalida: ""
                        })
                      }
                      //Se guardan los datos de ubicación en el campo rubicaciones
                      serial.rubicaciones = ubicaciones;
                      serial.ultimaUbicacion = ultimaUbicacion;
                    }
                  }
                } else {
                  if (serial.locacion !== locacionOriginal || serial.ubicacion !== ubicacionOriginal) {
                    serialesNCU = serialesNCU + (serialesNCU === "" ? serial.serialRecibaBTI : (", " + serial.serialRecibaBTI))
                    return
                  }
                }
                //Se guardan los cambios en recibaseriales
                serial.piezasenAlmacen =
                  serial.ubicacion === "Almacén" ? serial.cantidadRecibida : 0;
                serial.piezasenCuarentena =
                  serial.ubicacion === "Cuarentena" ? serial.cantidadRecibida : 0;
                delete serial.nuevo;
                delete serial.pagina;
                delete serial.editar;
                delete serial.createdAt;
                delete serial.updatedAt;
                delete serial.__typename;
                delete serial.locacionOriginal;
                delete serial.ubicacionOriginal;
                delete serial.statusOriginal;
                delete serial.scolor;
                delete serial.modificado;
                serial.Reg_Mod_Usuario = userName;
                serial.usuarioIncoming = nombreUsuario;
                setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                let upRecibaS = await API.graphql({
                  query: updateRecibaSeriales,
                  variables: { input: serial },
                });
                const recibaSerialMPID = serial.recibaSerialMPID;
                if (serial.recibaSerialMPID) {
                  delete serial.recibaSerialMPID;
                  //setMensajeAlert("Se intenta guardar la reciba serialesMP: " + JSON.stringify({ ...serial, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt }));
                  setMensajeAlert("Los datos se guardaron aunque el material ya no se encuentra en planta.");
                  await API.graphql({
                    query: updateRecibaSerialesMP,
                    variables: { input: { ...serial, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } },
                  });
                }
              })
            );
            setMensajeAlert("Ubicación actualizada");
            var dEnReciba = false;
            if (individual === true && statusOriginal != statusActual) {
              const enrecibaA = reciba.filter((reci) => reci.numero === formData.numero);
              dEnReciba = enrecibaA.length > 0 ? true : false;
              const serialesReciba = await ObtenerSeriales(formData.serialesID);//GetRecibaSeriales({ numero: { eq: formData.numero } });
              const enReciba = serialesReciba.filter((rserial) => rserial.status === "En reciba");
              const enAceptado = serialesReciba.filter((rserial) => rserial.status === "Aceptado");
              const enRechazado = serialesReciba.filter((rserial) => rserial.status === "Rechazado");
              estadoReciba = enReciba.length > 0 ? true : false;
              estadoRechazado = enRechazado.length > 0 ? true : false;
              estadoAceptado = enAceptado.length > 0 ? true : false;
            }
            if (individual === false || statusOriginal != statusActual) {
              const statusReciba =
                estadoReciba === false &&
                  estadoRechazado === false &&
                  estadoAceptado === true
                  ? "Aceptado"
                  : estadoReciba === false &&
                    estadoRechazado === true &&
                    estadoAceptado === false
                    ? "Rechazado"
                    : estadoReciba === false &&
                      estadoRechazado === true &&
                      estadoAceptado === true
                      ? "Parcialmente Rechazado"
                      : "En reciba";
              //setMensajeAlert("Problemas obtener el estatus");
              if (formData.status !== statusReciba) {
                formData.status = statusReciba;
                delete formData.createdAt;
                delete formData.updatedAt;
                delete formData.__typename;
                delete formData.indexpag;
                setMensajeAlert("Problemas al actualizar la reciba: " + JSON.stringify(formData));
                await API.graphql({
                  query: updateRecibaMutation,
                  variables: { input: formData },
                });
              }
            }
            const mensajeAdicional = serialesNCU === "" ? "" : "Problemas de concurrencia/material planeado para los seriales: " + serialesNCU;
            setMensajeAlert(mensajeAdicional === "" ? "Operación exitosa. " : "Operación finalizada; " + mensajeAdicional);
            setColor(mensajeAdicional === "" ? "primary" : "warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
            if (individual === false || dEnReciba === true) {
              updateFormData(initialFormState);
              fetchLocacion();
              fetchReciba();
              preciba();
            }
          } else {
            //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
            window.scrollTo(0, 0);
            setMensajeAlert(
              "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
              " volver a intentarlo"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            fetchReciba();
          }
        }
      } else {
        window.scrollTo(0, 0);
        if (individual === false) {
          updateFormData(initialFormState);
          fetchLocacion();
          fetchReciba();
          preciba();
        }
        setMensajeAlert("No se realizaron cambios");
        setColor("info");
        setAVisible(true);
        setCargando(false);
        setisDisabled(false);
      }
    } catch (e) {
      window.scrollTo(0, 0);
      //updateFormData(initialFormState);
      //setMensajeAlert("No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas");
      setColor("warning");
      setAVisible(true);
      setCargando(false);
      setisDisabled(false);
    }
  }
  //Desactiva la reciba y todos los seriales
  async function eliminarReciba() {
    setCargando(true);
    setAVisible(false);
    setisDisabled(true);
    try {
      //Se revisa si hay concurrencia.
      let filter = {
        numero: {
          eq: formData.numero,
        },
      };
      //Se declaran variables auxiliar para revisar la concurrencia y si el material ya fue planificado.
      var concurrencia = false;
      var planificado = false;
      //Se obtienen los datos de las recibas em cuestión.
      const recibaFromAPI = await ObtenerSeriales(formData.serialesID);//GetRecibaSeriales(filter);

      //Se revisa que ninguno de los contenedores de la reciba se haya planificado ya
      //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación
      await Promise.all(
        recibaFromAPI.map(async (recibaSerial) => {
          //Se revisa que algún contenedor de la reciba ya fue planificado
          if (recibaSerial.cantidadPlaneada > 0) planificado = true;
        })
      );
      const recibah = await GetRecibaID(formData.id);
      if (!recibah.id) {
        concurrencia = true;
      } else {
        if (recibah.updatedAt !== formData.updatedAt) {
          concurrencia = true;
        }
      }
      if (planificado) {
        window.scrollTo(0, 0);
        setMensajeAlert(
          "No fue posible realizar la operación: uno o más registros de la reciba ya fueron planificados"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        return;
      }
      //Si concurrencia es igual a falso
      if (concurrencia === false) {
        delete formData.createdAt;
        delete formData.updatedAt;
        delete formData.__typename;
        delete formData.indexpag;
        formData.activo = false;
        await API.graphql({
          query: updateRecibaMutation,
          variables: { input: formData },
        });
        await Promise.all(
          recibaFromAPI.map(async (serial, i) => {
            if (serial.activo === true && serial.recibaID !== "") {
              delete serial.createdAt;
              delete serial.updatedAt;
              delete serial.__typename;
              delete serial.locacionOriginal;
              delete serial.scolor;
              serial.activo = formData.activo;
              serial.piezasEnPlanta = false;
              serial.Reg_Mod_Usuario = userName;
              await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: serial },
              });

              if (serial.recibaSerialMPID) {
                //Se actualizan los datos en la tabla de serialesMP
                setMensajeAlert("No se pudo eliminar la notificación nueva; ");
                await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: serial.recibaSerialMPID, } } });
              }
            }
          })
        );
        //Se guardan los datos en Resumen de operacion
        formData.recibaSerialID = formData.serialesID;
        const rOperacion = await manageResumenOperacion(formData.fechaDeReciba, formData, "Reciba", userName, formData.id);

        setMensajeAlert("Operación exitosa");
        setColor("primary");
        setAVisible(true);
        setCargando(false);
        updateFormData(initialFormState);
        setisDisabled(false);
        fetchReciba();
        preciba();
      } else {
        //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
        window.scrollTo(0, 0);
        setMensajeAlert(
          "No fue posible realizar la operación: existe concurrencia, se requiere recargar los datos y " +
          " volver a intentarlo"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        //fetchReciba();
      }
    } catch (e) {
      window.scrollTo(0, 0);
      //updateFormData(initialFormState);
      setMensajeAlert(
        "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
      );
      setColor("warning");
      setAVisible(true);
      setisDisabled(false);
    }
  }
  // Obtiene la catidad recibida
  function cantidadRecibidaS(list) {
    var cantidadrecibidaserial = 0;
    list.map((series) => {
      if (series.cantidadRecibida !== "" && series.activo === true)
        cantidadrecibidaserial =
          cantidadrecibidaserial + parseInt(series.cantidadRecibida);
    });
    return cantidadrecibidaserial;
  }
  // Obtiene la catidad recibida
  function cantidadRecibidaxParte(list, index) {
    var cantidadrecibidaserial = 0;
    list.map((series) => {
      if (
        series.cantidadRecibida !== "" &&
        series.activo === true &&
        list[index].numerodeParte === series.numerodeParte
      )
        cantidadrecibidaserial =
          cantidadrecibidaserial + parseInt(series.cantidadRecibida);
    });
    return cantidadrecibidaserial;
  }

  // Revisa si faltan datos en las series,  las cantidades recibidas y los seriales repetidos
  function faltanDatosF(list) {
    var fdatos = false;
    list.map((series, i) => {
      if (series.activo === true && series.ultimoxpacking === false) {
        if (
          !series.materialEn ||
          !series.po ||
          !series.materialEnCantidad ||
          !series.packing ||
          !series.lote ||
          !series.serial ||
          !series.cantidadRecibida ||
          !series.numerodeParte ||
          !series.productoID ||
          series.serialDuplicado
        )
          fdatos = true;
      }
    });
    return fdatos;
  }

  //Obtiene los datos guardados de Locación
  async function LocacionOcupada(ID) {
    let filter = {
      id: {
        eq: ID,
      },
      ocupado: {
        eq: true,
      },
    };
    var ocupado = false;
    //Se obtienen los datos de las locaciones ocupadas
    const locacionesFromAPI = await GetLocaciones(filter);
    if (locacionesFromAPI.length) ocupado = true;

    return ocupado;
  }

  async function liberarlocacion(locacion, espacioOcupado) {
    try {
      delete locacion.createdAt;
      delete locacion.updatedAt;
      delete locacion.__typename;
      locacion.Reg_Mod_Usuario = userName;
      locacion.ocupado = false;
      locacion.fechaDeliberacion = now;
      locacion.espacioOcupado = espacioOcupado
        ? locacion.espacioOcupado - espacioOcupado
        : 0; //locacion.espacio-locacion.espacioOcupado;
      await API.graphql({
        query: updateLocacion,
        variables: { input: locacion },
      });
      await fetchLocacionDisponible();
      await setMensajeAlert("Liberación exitosa");
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert("Hay problemas liberando las locaciones");
      setColor("warning");
      setAVisible(true);
    }
  }
  async function ocuparLocacion(locacion) {
    try {
      delete locacion.createdAt;
      delete locacion.updatedAt;
      delete locacion.__typename;
      locacion.Reg_Mod_Usuario = userName;
      locacion.ocupado = true;
      locacion.fechaDeOcupacion = now;
      await API.graphql({
        query: updateLocacion,
        variables: { input: locacion },
      });
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert("Hay problemas registrando las locaciones");
      setColor("warning");
      setAVisible(true);
    }
  }
  async function managelocacion(anterior, actual, name, index, list, espacio) {
    //setMensajeAlert("Anterior " + anterior + "Actual " + actual + "Name " + name + "Index " + index + "Espacio " + espacio );
    //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
    //setColor("warning");
    //setAVisible(true);
    try {
      // Revisa si la locación actual es diferente a vacio
      if (actual !== "") {
        //Se revisa si la locación elegida no se encuentra ocupada
        //Se obtiene el registro de la locación actual
        const actualLocacion = locaciones.filter(
          (locacion) => locacion.locacion === actual
        );
        if (actualLocacion[0]) {
          if ((await LocacionOcupada(actualLocacion[0].id)) === false) {
            delete actualLocacion[0].createdAt;
            delete actualLocacion[0].updatedAt;
            delete actualLocacion[0].__typename;
            actualLocacion[0].Reg_Mod_Usuario = userName;
            actualLocacion[0].ocupado = true;
            actualLocacion[0].fechaDeOcupacion = now;
            list[index].espacioOcupado =
              actualLocacion[0].espacioOcupado > 0
                ? actualLocacion[0].espacio - actualLocacion[0].espacioOcupado
                : actualLocacion[0].espacio;
            actualLocacion[0].espacioOcupado =
              espacio === 0 ? actualLocacion[0].espacio : espacio;
            await API.graphql({
              query: updateLocacion,
              variables: { input: actualLocacion[0] },
            });
            list[index][name] = actual;
            /* await fetchLocacionDisponible();
                         await setMensajeAlert("La locación '" + actual + "' se guardó con éxito");   */
          } else {
            setMensajeAlert(
              "La locación '" +
              actual +
              "' ya se encuentra ocupada, elige otra locación por favor"
            );
            //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
            setColor("warning");
            setAVisible(true);
            window.scrollTo(0, 0);
          }
        }
      } else {
        list[index][name] = actual;
        list[index].espacioOcupado = 0;
      }

      if (anterior !== "" && list[index].locacionOriginal !== anterior) {
        if (list[index].materialEn === "Caja") {
          const llocacion = await list.filter(
            (reciba) =>
              reciba.lote === list[index].lote &&
              reciba.materialEn === "Caja" &&
              reciba.locacion === anterior
          );
          //Si solo existe un registro de la locación anterior ocupada en Almacén.
          if (llocacion.length === 0) {
            //Se libera la locación anterior
            const locacionae = await locacionesSinFiltro.filter(
              (locacion) => locacion.locacion === anterior
            );
            if (locacionae[0]) {
              delete locacionae[0].createdAt;
              delete locacionae[0].updatedAt;
              delete locacionae[0].__typename;
              locacionae[0].Reg_Mod_Usuario = userName;
              locacionae[0].ocupado = false;
              locacionae[0].fechaDeliberacion = now;
              locacionae[0].espacioOcupado =
                locacionae[0].espacio - list[index].espacioOcupado > 0
                  ? locacionae[0].espacio - list[index].espacioOcupado
                  : 0;
              await API.graphql({
                query: updateLocacion,
                variables: { input: locacionae[0] },
              });
              //await liberarlocacion(locacionae[0]);
            }
          }
        }
      }
      await setLocaciones([]);
      await fetchLocacionDisponible();
      //setMensajeAlert("La locación '" + anterior + "' liberada");
      //Si se habia marcado una locación como ocupada, se desocupa.
      /*if (anterior !== "" && list[index].locacionOriginal !== anterior) {
                const locacionae = locacionesSinFiltro.filter(locacion => locacion.locacion === anterior)
                if (locacionae[0]) {
                    liberarlocacion(locacionae[0]);
                }
            }  */
      //Si se trata de una caja, se envía a revisar la posibilidad de la asignación de la misma locación a todas las cajas
      /*if (list[index].materialEn==="Caja"){
                await asignacionLocacionCaja(list,anterior, actual, list[index].lote)
                setMensajeAlert("La locación '" + actual + "' se asignó de manera correcta");    
            }*/
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert("Hay problemas registrando las locaciones");
      setColor("warning");
      setAVisible(true);
      //fetchLocacionDisponible();
    }
    // const anteriorLocacion = locaciones.filter(locacion =>locacion.locacion===actual);
  }
  function asignacionLocacionCaja(list, locacionan, locacionac, lote) {
    Promise.all(
      list
        .filter(
          (reciba) =>
            reciba.lote === lote &&
            reciba.locacion === locacionan &&
            reciba.ubicacion === "Almacén"
        )
        .map((recibas) => {
          recibas.locacion = locacionac;
          return list;
        })
    );
  }
  // handle input change
  function handleInputChangeSerial(e, index, list) {
    const { name, value } = e.target;
    list[index][name] = name === "serial" ? value.toUpperCase() : value;
    if (name !== "materialEn") {
      list = agregarNumeroParte(list, index);
    }
    if (name === "serial") {
      list.map((dserial) => {
        if (dserial.serial === "ND") {
          dserial.serialDuplicado = false;
        } else {
          const flist = list.filter(
            (drecibaf) => drecibaf.serial === dserial.serial
          );
          const rlist = serialesRepetidos.filter(
            (dreciba) => dreciba.cliente === formData.cliente && dreciba.serial == dserial.serial
          );

          if ((flist.length > 1) || (rlist.length > 0)) {
            dserial.serialDuplicado = true;
          } else {
            dserial.serialDuplicado = false;
          }
        }
      });
    }
    //siguienteFoco();
    /*if (name === "serial"){
            list[index]["serialDuplicado"] = true;
        }*/
    return list;
  }
  // handle input change
  function handleInputChangeProducto(e, index, list) {
    const { name, value } = e.target;
    var productosFromAPI = [];
    if (name === "productoID")
      productosFromAPI = productos.filter(
        (producto) => producto.id === e.target.value
      );
    if (name === "numerodeParte")
      productosFromAPI = productos.filter(
        (producto) =>
          producto.numerodeParte.toLowerCase().trim() ===
          e.target.value.toLowerCase().trim()
      );

    if (productosFromAPI.length > 0) {
      delete list[index].piezasXRack;
      delete list[index].rackTipo;
      delete list[index].precioUnitario;
      delete list[index].divisa;
      delete list[index].Pcoat;
      delete list[index].Ecoat;
      delete list[index].Platinado;
      delete list[index].precioUnitarioP;
      delete list[index].precioUnitarioPC;
      Promise.all(
        productosFromAPI.map((producto) => {
          list[index].productoID = producto.id;
          list[index].numerodeParte = producto.numerodeParte.trim();
          list[index].descripcion = producto.descripcion;
          list[index].divisa = producto.divisa;
          list[index].piezasXRack = producto.piezasXRack;
          list[index].rackTipo = producto.rackTipo;
          if (producto.Pcoat) {
            list[index].Pcoat = producto.Pcoat;
          }
          if (producto.Ecoat) {
            list[index].Ecoat = producto.Ecoat;
          }
          if (producto.Platinado) {
            list[index].Platinado = producto.Platinado;
          }
          if (producto.precioUnitario) {
            list[index].precioUnitario = producto.precioUnitario;
            if (!producto.Ecoat) {
              list[index].Ecoat = true;
            }
          }
          if (producto.precioUnitarioP) {
            list[index].precioUnitarioP = producto.precioUnitarioP;
          }
          if (producto.precioUnitarioPC) {
            list[index].precioUnitarioPC = producto.precioUnitarioPC;
          }
          return list;
        })
      );
      list[index].parteValido = true;
    } else {
      list[index][name] = value;
      list[index].parteValido = false;
      list[index].productoID = "";
      delete list[index].piezasXRack;
      delete list[index].rackTipo;
      delete list[index].precioUnitario;
      delete list[index].divisa;
      delete list[index].Pcoat;
      delete list[index].Ecoat;
      delete list[index].Platinado;
      delete list[index].precioUnitarioP;
      delete list[index].precioUnitarioPC;
      list[index].descripcion = "";
    }
    list = agregarNumeroParte(list, index);
    //siguienteFoco();
    return list;
  }

  function onChangescheck(e, index, list) {
    const { name, checked } = e.target;
    list[index][name] = checked;

    return list;
  }

  // handle input change
  function handleInputChangeCantidad(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;

    if (e.target.value === "" || re.test(e.target.value)) {
      list[index][name] = value;
    }
    if (name !== "materialEnCantidad") list = agregarNumeroParte(list, index);
    //siguienteFoco();
    return list;
  }
  function agregarNumeroParte(list, index) {
    if (list[index].ultimoxpacking === true) {
      list[index].ultimoxpacking = false;
      list = [
        ...list,
        {
          materialEn: list[index].materialEn,
          materialEnCantidad: list[index].materialEnCantidad,
          packing: list[index].packing,
          packingindex: list[index].packingindex,
          productoID: "",
          numerodeParte: "",
          po: list[index].po,
          descripcion: "",
          cantidadporParte: 0,
          recibaID: "",
          lote: agregarLoteFaltante ? "ND" : "",
          sombreado: false,
          primeroxpacking: false,
          ultimoxpacking: true,
          serial: "",
          cantidadRecibida: "",
          ubicacion: "Reciba",
          locacion: "",
          fechaDeUbicacion: "",
          horaDeUbicacion: "",
          orden: list[index].orden + 1,
          status: "En reciba",
          quienInspecciono: "",
          comentariosdeinspeccion: "",
          activo: true,
          Reg_Ins_Usuario: userName,
          manual: true,
          parteValido: false,
          fid: "i" + inputList.length,
          espacioOcupado: 0,
        },
      ];
    }
    return list;
  }
  function siguienteFoco() {
    var nextSibling = null;

    if (nFocus === "numerodeParte") {
      //Busca el siguiente elemento para mandar el foco
      nextSibling = document.querySelector(`input[id=si${parseInt(iFocus)}]`);
    }
    if (nFocus === "productoID") {
      //Busca el siguiente elemento para mandar el foco
      nextSibling = document.querySelector(`input[id=si${parseInt(iFocus)}]`);
    }
    if (nFocus === "serial") {
      //Busca el siguiente elemento para mandar el foco
      nextSibling = document.querySelector(`input[id=ci${parseInt(iFocus)}]`);
    }
    if (nFocus === "cantidadRecibida") {
      //Busca el siguiente elemento para mandar el foco
      nextSibling = document.querySelector(`input[id=li${parseInt(iFocus)}]`);
    }
    if (nFocus === "lote") {
      //Busca el siguiente elemento para mandar el foco
      nextSibling = document.querySelector(
        `input[id=ni${parseInt(iFocus + 1)}]`
      );
    }

    // If found, focus the next field
    if (nextSibling !== null) {
      nextSibling.focus();
    }
  }
  function handleFocus(e, index) {
    const { name, value, id } = e.target;
    /*setMensajeAlert("Nombre " + name + ", valor " + value + ", id " + id + ", index " + index);
    setColor("primary");
    setAVisible(true);*/
    setIFocus(index);
    setNFocus(name);
    /*if (name==="numerodeParte")
            inputList[index][name]="Pimerdato"; */
  }
  function handleScanscanner(data) {
    inputList[iFocus][nFocus] = data;
  }
  function handleErrorscanner(err) {
    console.error(err);
  }
  // handle input change
  function handleInputChangeLocacion(e, index, list) {
    const { name, value } = e.target;
    if (list[index].ubicacion === "Almacén") {
      managelocacion(list[index][name], value, name, index, list, 0);
    } else {
      list[index][name] = value;
      list[index].espacioOcupado = 0;
      // updateFormData(()=>({ ...formData, [serial]: list}));
    }
    return list;
  }
  //(anterior, actual, name, index, list, espacio)
  function handleInputChangeEspacio(e, index, list) {
    const { name, value } = e.target;
    if (list[index].ubicacion === "Almacén") {
      const actualLocacion = locacionesSinFiltro.filter(
        (locacion) => locacion.locacion === list[index].locacion
      );
      if (actualLocacion[0]) {
        delete actualLocacion[0].createdAt;
        delete actualLocacion[0].updatedAt;
        delete actualLocacion[0].__typename;
        actualLocacion[0].Reg_Mod_Usuario = userName;
        actualLocacion[0].ocupado =
          value === actualLocacion[0].espacio ||
            actualLocacion[0].espacioOcupado + value >= actualLocacion[0].espacio
            ? true
            : false;
        actualLocacion[0].fechaDeOcupacion = "";
        actualLocacion[0].espacioOcupado = value;
        API.graphql({
          query: updateLocacion,
          variables: { input: actualLocacion[0] },
        });
        list[index].espacioOcupado = value;
        fetchLocacionDisponible();
      }
    } else {
      list[index].espacioOcupado = 0;
    }
    list[index][name] = value;
    return list;
  }

  function ordernarserialesxlote(list, i) {
    const aux = list[i];
    var aux2 = {};
    var aux3 = {};
    var reordenar = false;
    var buscando = true;
    const loteindex = list[i].loteindex;
    list.map((serial, index) => {
      if (serial.activo === true) {
        if (reordenar === true) {
          aux3 = serial;
          list[index] = aux2;
          aux2 = aux3;
        }

        if (buscando === true) {
          if (index > 0) {
            if (
              serial.loteindex !== loteindex &&
              list[index - 1].loteindex === loteindex
            ) {
              aux2 = serial;
              list[index] = aux;
              buscando = false;
              reordenar = true;
            }
          }
        }
      }
      // return serial;
    });
    /*list=list.sort((a,b)=>
            a.indexlotepadre>b.indexlotepadre? 1:a.indexlotepadre<b.indexlotepadre?-1:0);*/
    return list;
  }

  function handleChangeInputType(index, list) {
    list[index].manual = !list[index].manual;
    return list;
  }

  // handle click event of the Add button
  function handleAddClick(index, list) {
    list[index].ultimoxlote = false;
    if (
      list[list.length - 1].indexlotepadre !== list[list.length - 2].loteindex
    ) {
      ordernarserialesxlote(list, list.length - 1);
    }
    return list;
  }

  // handle click event of the Remove button
  function handleRemoveClick(index, list) {
    if (list[index].ultimoxpacking === true)
      list[index - 1].ultimoxpacking = true;
    if (list[index].recibaID === "") list.splice(index, 1);
    else list[index].activo = false;

    updateFormData({ ...formData, cantidadRecibida: cantidadRecibidaS(list) });
    return list;
  }
  // handle click event of the Remove button
  function handleRemovePackingClick(index, list) {
    inputList.map((seriales, i) => {
      if (seriales.packingindex === list[index].packingindex) {
        if (seriales.recibaID === "") inputList.splice(i, 1);
        else inputList[i].activo = false;
      }
    });
    list.splice(index, 1);
    /* if (list[index].recibaID==="")
             list.splice(index, 1);    
         else
             list[index].activo=false; */
    updateFormData({
      ...formData,
      cantidadRecibida: cantidadRecibidaS(inputList),
    });
    return list;
  }
  // handle click event of the Remove button
  function handleRemoveParteClick(index, list) {
    inputList.map((seriales, i) => {
      if (seriales.parteindex === list[index].parteindex) {
        inputList.splice(i, 1);
      }
    });
    list.splice(index, 1);
    return list;
  }

  function agregarLote(list) {
    //setFaltanDatos(true);
    setLotes(lotes + 1);
    return list;
  }
  function agregarPacking(index, list) {
    setInputList([
      ...inputList,
      {
        materialEn: "Contenedor",
        materialEnCantidad: 1,
        packing: "",
        packingindex: packings,
        po: list[index].po,
        productoID: "",
        numerodeParte: "",
        descripcion: "",
        cantidadporParte: 0,
        recibaID: "",
        lote: agregarLoteFaltante ? "ND" : "",
        sombreado: false,
        primeroxpacking: true,
        ultimoxpacking: false,
        serial: "",
        cantidadRecibida: "",
        ubicacion: "Reciba",
        locacion: "",
        fechaDeUbicacion: "",
        horaDeUbicacion: "",
        orden: 1,
        status: "En reciba",
        quienInspecciono: "",
        comentariosdeinspeccion: "",
        activo: true,
        Reg_Ins_Usuario: userName,
        manual: true,
        parteValido: false,
        fid: "i" + inputList.length,
        espacioOcupado: 0,
      },
      {
        materialEn: "Contenedor",
        materialEnCantidad: 1,
        packing: "",
        packingindex: packings,
        po: list[index].po,
        productoID: "",
        numerodeParte: "",
        descripcion: "",
        cantidadporParte: 0,
        recibaID: "",
        lote: agregarLoteFaltante ? "ND" : "",
        sombreado: false,
        primeroxpacking: false,
        ultimoxpacking: true,
        serial: "",
        cantidadRecibida: "",
        ubicacion: "Reciba",
        locacion: "",
        fechaDeUbicacion: "",
        horaDeUbicacion: "",
        orden: 2,
        status: "En reciba",
        quienInspecciono: "",
        comentariosdeinspeccion: "",
        activo: true,
        Reg_Ins_Usuario: userName,
        manual: true,
        parteValido: false,
        fid: "i" + (inputList.length + 1),
        espacioOcupado: 0,
      },
    ]);

    setPackings(packings + 1);
    //setFaltanDatos(true);
    return list;
  }

  function eliminarLote() {
    const lotesn = lotes - 1;
    const lote = "lote" + lotesn.toString();
    //liberarLocacionesLote (lotes-1);
    inputList.map((seriales, index) => {
      if (seriales.loteindex === lotes) {
        if (seriales.recibaID === "") inputList.splice(index);
        else seriales.activo = false;
      }
    });
    setLotes(lotes - 1);
    updateFormData(() => ({
      ...formData,
      cantidadRecibida: cantidadRecibidaS(inputList),
    }));
  }
  function preciba() {
    setLotes(1);
    setEditar(false);
    setInputList([]);
    setPackings(1);
    setisDisabled(false);
    fetchReciba();
    updateFormData(initialFormState);
    updateFormState(() => ({ ...formState, formType: "Reciba" }));
  }
  function cancelarReciba() {
    fetchReciba();
    preciba();
  }
  function cancelarRecibaIncoming() {
    setAVisible(false);
    liberarLocaciones();
    fetchLocacion();
    fetchReciba();
    preciba();
  }
  function buscarpor(e) {
    setAVisible(false);
    setSearchBy(e.target.value);
    if (search && e.target.value !== "fecha")
      busqueda(
        recibaSinFiltro,
        estadoReciba,
        e.target.value,
        search,
        currentPage
      );
  }
  function onSearch(e) {
    setAVisible(false);
    busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage);
  }
  function onSearchFecha(e) {
    setAVisible(false);
    setSearch(e.target.value);
    busqueda(
      recibaSinFiltro,
      estadoReciba,
      searchBy,
      e.target.value,
      currentPage
    );
  }
  //Envía al formulario para crear una nueva reciba
  async function nuevaReciba() {
    setCargando(true);
    setisDisabled(false);
    setAVisible(false);
    setEditar(false);
    setFaltanDatos(false);
    setNFocus("numerodeParte");
    setProductos([]);
    setIFocus(0);
    setAgregarLoteFaltante(true);
    setInputList([
      {
        materialEn: "Contenedor",
        materialEnCantidad: 1,
        packing: "",
        packingindex: 0,
        po: "",
        productoID: "",
        numerodeParte: "",
        descripcion: "",
        cantidadporParte: 0,
        recibaID: "",
        lote: "ND",
        sombreado: false,
        primeroxpacking: true,
        ultimoxpacking: false,
        serial: "",
        cantidadRecibida: "",
        ubicacion: "Reciba",
        locacion: "",
        fechaDeUbicacion: "",
        horaDeUbicacion: "",
        orden: 1,
        status: "En reciba",
        quienInspecciono: "",
        comentariosdeinspeccion: "",
        activo: true,
        Reg_Ins_Usuario: userName,
        manual: true,
        parteValido: false,
        fid: "i0",
        espacioOcupado: 0,
      },
      {
        materialEn: "Contenedor",
        materialEnCantidad: 1,
        packing: "",
        packingindex: 0,
        po: "",
        productoID: "",
        numerodeParte: "",
        descripcion: "",
        cantidadporParte: 0,
        recibaID: "",
        lote: "ND",
        sombreado: false,
        primeroxpacking: false,
        ultimoxpacking: true,
        serial: "",
        cantidadRecibida: "",
        ubicacion: "Reciba",
        locacion: "",
        fechaDeUbicacion: "",
        horaDeUbicacion: "",
        orden: 2,
        status: "En reciba",
        quienInspecciono: "",
        comentariosdeinspeccion: "",
        activo: true,
        Reg_Ins_Usuario: userName,
        manual: true,
        parteValido: false,
        fid: "i1",
        espacioOcupado: 0,
      },
    ]);
    setInputListPacking([{ packing: "", packingindex: 0, po: "" }]);
    setPackings(1);
    setPartes(1);
    updateFormData({
      ...formData,
      Reg_Ins_Usuario: userName,
      horaDeReciba: Moment(new Date()).format("HH:mm"),
    });
    updateFormState(() => ({ ...formState, formType: "Nueva Reciba" }));
    //inputEl.current.focus();
    setCargando(false);
  }
  function sumanumeros(arr) {
    let sum = 0;
    for (let num of arr) {
      sum = sum + num;
    }
    return sum;
  }
  async function imprimirInspeccion(reciba) {
    window.scrollTo(0, 0);
    setCargando(true);
    setFaltanDatos(false);
    setAVisible(false);
    const seriales = await fetchRecibaSerialporID(reciba, "Imprimir");
    setInputList(seriales.sort((a, b) => a.numerodeParte > b.numerodeParte ? 1 :
      a.numerodeParte < b.numerodeParte ? -1 : 0));
    setCargando(false);
    handlePrintTEV();
  }
  //Vista por número de parte
  function onChangescheckALF(e) {
    setAgregarLoteFaltante(e.target.checked);
    inputList.map((seriales) => {
      if (e.target.checked === true) {
        if (seriales.lote === "") {
          seriales.lote = "ND";
        }
      } else {
        if (seriales.lote === "ND") {
          seriales.lote = "";
        }
      }
    });

  }
  /* function addfile(event) {
         let file = event.target.files[0];
         let fileReader = new FileReader();
         fileReader.readAsArrayBuffer(file);
         fileReader.onload = (e) => {
             let arrayBuffer = fileReader.result;
             var data = new Uint8Array(arrayBuffer);
             var arr = new Array();
             for (var i = 0; i != data.length; ++i)
                 arr[i] = String.fromCharCode(data[i]);
             var bstr = arr.join("");
             var workbook = xlsx.read(bstr, { type: "binary" });
             var first_sheet_name = workbook.SheetNames[0];
             var worksheet = workbook.Sheets[first_sheet_name];
             //[["Created " + new Date().toISOString()]],
             var output = recibaDD.map(function (obj) {
                 return Object.keys(obj).sort().map(function (key) {
                     return obj[key];
                 });
             });
             xlsx.utils.sheet_add_aoa(worksheet, output, { origin: -1 });
             xlsx.writeFile(workbook, "Report.xlsx");
   
             console.log(xlsx.utils.sheet_to_json(worksheet, { raw: true }));
             var arraylist = xlsx.utils.sheet_to_json(worksheet, { raw: true });            
             navigator.clipboard.writeText(["Created " + new Date().toISOString()]);
         };
     }*/
  return {
    ppreciba,
    pincoming,
    pdescargarreciba,
    pdescargarincoming,
    formType,
    color,
    aVisible,
    mensajeAlert,
    cargando,
    mRecibas,
    mRecibasNP,
    serialesRepetidos,
    agregarLoteFaltante,
    inputList,
    clientes,
    formData,
    inputListPacking,
    packings,
    productos,
    isDisabled,
    modal1,
    modal2,
    modal3,
    locaciones,
    searchBy,
    estadoReciba,
    search,
    reciba,
    rfechaini,
    rfechafin,
    currentPage,
    recordPerPage,
    totalRecords,
    pageRange,
    registrosPorPagina,
    modal,
    faltanDatos,
    recibaSerialesSinFiltro,
    mEstatusUbicacion,
    mDatosInspeccion,
    nFocus,
    componentRefTEV,
    nombreUsuario,
    onChangescheckALF,
    handlePrintTEV,
    imprimirInspeccion,
    siguienteFoco,
    setMEstatusUbicacion,
    setMDatosInspeccion,
    onDismiss,
    preciba,
    setIndexImp,
    handleError,
    handleScan,
    handleScanI,
    onChangeCliente,
    onChanges,
    setInputListPacking,
    handleInputChangePacking,
    handleInputChangePO,
    agregarPacking,
    handleRemovePackingClick,
    setInputList,
    handleInputChangeProducto,
    onChangescheck,
    handleFocus,
    handleInputChangeSerial,
    handleInputChangeCantidad,
    handleChangeInputType,
    handleRemoveClick,
    guardarReciba,
    cancelarReciba,
    toggle1,
    toggle2,
    toggle3,
    updateReciba,
    cancelarRecibaIncoming,
    aceptarEliminar,
    setInputUbicaciones,
    onChangesUbicacion,
    handleInputChangeLocacion,
    toggle,
    handleInputChangeEspacio,
    onChangesFechaUbicacion,
    guardarIncomming,
    nuevaReciba,
    buscarpor,
    onestadoReciba,
    setSearch,
    onSearchFecha,
    handlePageChange,
    onSearch,
    onChangesRFecha,
    fetchReciba,
    cliclMostrar,
    clicEditar,
    clicEliminar,
    clicDescargarDatos,
    clicDescargarDatosReciba,
    cliclIncoming,
  };
}
